import {Link, useNavigate, useParams} from 'react-router-dom'
import {
  activedPOT,
  addPieceProp,
  changeClientOnDemande,
  getAdresseDepotBySourceDemande,
  getAdresseFacturationData,
  getClient,
  getClientAdresses,
  getClientContacts,
  getClientDemandeImmat,
  getClientOtherData,
  getDemandeProposee,
  getListePieceViaType,
  getMarqueVehicule,
  getModeleVehicule,
  getOneDemandeImmat,
  getProvenancePiece,
  getResultatAIPiece,
} from '../../../../../components/requests'
import React, {useCallback, useEffect, useRef, useState} from 'react'
import {
  ModeleAdresseDepot,
  ModeleClient,
  ModeleClientContact,
  ModeleClientDemande,
  modeleClientInitValues,
  ModeleClientOtherData,
  modeleClientOtherDataInitValues,
  ModelePieceItemStock,
} from '../../../../../components/Models'
import {useLocation} from 'react-router'
import {LoadingData} from '../../../../../components/LoadingData'
import {ShopModal} from '../../Components/shop/ShopModal'
import {usePanier} from './PanierContext'
import {useFormik} from 'formik'
import {Pagination} from '../../../../../components/Pagination'
import OnMarket from '../../Components/Televendeur/OnMarket'
import ModalAI from '../../Components/ModalAI'
import {toast} from 'react-toastify'
import {Tooltip} from 'react-tooltip'
import {PieceNotAvailable} from '../../Components/Televendeur/PieceNotAvailable'
import CommentaireClientDemande from '../../../commentaireClientDemande/CommentaireClientDemande'
import moment from 'moment'
import {DetailsModal} from '../../../catalogues/components/DetailsModal'
import AddToPanierButton from '../../Components/AddToPanierButton'
import {
  formatTypePieceSansNom,
  shouldDisplayFonctionnalite,
} from '../../../../../components/helpers'
import {copyText, renderPieceStatus} from '../../../../../components/renders'
import ModalPOT from '../../Components/Televendeur/ModalPOT'
import VehicleSearchFilter from '../../Components/VehicleSearchFilter'
import ClientInfos from '../../Components/ClientInfos'
import DemandeAssignation from '../../Components/Televendeur/DemandeAssignation'
import HeaderDemandeTraitement from '../../Components/Televendeur/HeaderDemandeTraitement'
import AdresseClient from '../../Components/Televendeur/AdresseClient'
import {useAuth} from '../../../../modules/auth'
import ProvenanceModal from './ProvenanceModal'
import ResearchClientModal from '../../Components/ResearchClientModal'
import ChoixContactModal from '../../Components/ChoixContactModal'
import ClientMoreInfos from '../../Components/Televendeur/ClientMoreInfos'
import AddClientModal from '../../Components/AddClientModal'
import {useFilAriane} from '../../../../contexts/FilArianeContext'
import axios from 'axios'
import ImgPieceBlank from '../../../../../components/icon/ImgPieceBlank'
import ConfirmVBModal from '../../Components/ConfirmVBModal'
import {DemontageModal} from './DemontageModal'
import ClientAdresseFormModal from '../../../shop/clients/components/ClientAdresseFormModal'
import DemandePj from '../../Components/DemandePj'
import {FileWithPreview} from '../../../../../components/MutliFilePicker'
import Swal from 'sweetalert2'

type LocationState = {
  // panier: any
  // immatriculation: string
  immat: string
  quantity: number
  setPanierArray: any
  clientId: number
  demandeId: number
  demandeImmatId: number
  redirectToClientDemande: boolean
  refConst: string | null
  marque: string | null
  modele: string | null
  idModele: string | null
  isViaModele: boolean
  isHorsType: boolean
  pieceQuantity: number
  idPiecePropose: number
  dataClientInfos: any
  otherData: any
  // loadingCLientInfo: boolean
  pieces: any
  idDemandePiece: number
  isProspect: boolean
  immatriculationNonTrouvee: string | null
  dataVehicle: any
  natVehicle: string
  nomTP: any
  piece: any
  tauxRemise: number
  prixTransport: number
  isFromPOT: boolean
  isFromClient: boolean
  selectedPiecesFromVehicle: any
  isAssign: any
  isAvailable: boolean
  isHorsNomenclature: any
  idTypePieceFiltered: number
  typePieceHnFiltered: any
  isFromUrlFiltered: any
  typePieceFiltered: any
  clientAdresses: any
  demandeClient: any
  filters: any
  // handleDismiss: any
  fromListePieceStock: boolean
  idTypePiece: number
  updatedAdresseLivInfo: any
  updatedAdresseFactInfo: any
  updatedFinalAdresseLivInfo: any
  updatedFinalAdresseFactInfo: any
  isAdresseUpdated: boolean
  adresseFacturation: any
  errorsFac: any
  errorsLiv: any
  requierdFieldFac: any
  requierdFieldLiv: any
  contactedByBloc: string
  contentCommunication: string
  contactedBy: any
  searchTerm: string | undefined
  clientDemandeStatus: string | null
  retraitDepot?: any
  commentaireInterne?: any
  selectedSite?: any
  imagesDemandePj?: any
  statePagination?: any
}

const ListePieceStock = (props) => {
  const params = useParams()
  const navigate = useNavigate()
  const [listPiecesArr, setListPieceArr] = useState<ModelePieceItemStock[]>([])
  const [prixTransport, setPrixTransport] = useState(0)
  const location = useLocation()
  const state = location.state as LocationState | undefined
  const [loading, setLoading] = useState(false)
  const locationState = location.state as LocationState | null
  const [tauxRemise, setTauxRemise] = useState(locationState?.tauxRemise ?? 0)
  const {panier, setPanier} = usePanier()
  const [activePieces, setActivePieces] = useState<number[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [counter, setCounter] = useState<number>(0)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [isSearch, setIsSearch] = useState(false)
  const [isNotAvailable, setIsNotAvailable] = useState<boolean>(false)
  const [selectedSearchValue, setSelectedSearchValue] = useState<any>('')
  const [clearInput, setClearInput] = useState<boolean>(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [pieceSpinner, setPieceSpinner] = useState<boolean>(false)
  const [resultShowPiece, setResultShowPiece] = useState<boolean>(false)
  const [pieceTypePiece, setPieceTypePiece] = useState<string>('')
  const modalRef = useRef<HTMLDivElement | null>(null)
  const [modalContent, setModalContent] = useState<string>('')
  const [loadingModalContent, setLoadingModalContent] = useState<boolean>(true)
  const [marqueV, setMarqueV] = useState<string>('')
  const [modeleV, setModeleV] = useState<string>('')
  const [versionV, setVersionV] = useState<string>('')
  const [vinV, setVinV] = useState<string>('')
  const [energieV, setEnergieV] = useState<string>('')
  const [numSerieV, setNumSerieV] = useState<string>('')
  const [datePremCircV, setDatePremCircV] = useState<string>('')
  const [nomTP, setNomTP] = useState<string>('')
  const [showTable, setShowTable] = useState(true)
  const [dataToDisplayVoirToutes, setDataToDisplayVoirToutes] = useState<any>()
  const [marqueVehicule, setMarqueVehicule] = useState<any | undefined>([])
  const [modeleVehicule, setModeleVehicule] = useState<any | undefined>([])
  const [allMarqueVehicule, setAllMarqueVehicule] = useState<any | undefined>([])
  const [allModeleVehicule, setAllModeleVehicule] = useState<any | undefined>([])
  const [valueMarque, setValueMarque] = useState<any>([])
  const [valueModele, setValueModele] = useState<any>([])
  const [checkCopy, setCheckCopy] = useState<string | null>(null)
  const [idTypePiece, setIdTypePiece] = useState<any>(() => {
    if (state?.isFromUrlFiltered) {
      return state?.typePieceFiltered?.id ?? null
    }
    return state?.selectedPiecesFromVehicle?.[0]?.typePiece?.id ?? null
  })

  const [searchValue, setSearchValue] = useState<any>(() => {
    if (state?.isFromUrlFiltered) {
      return state?.typePieceFiltered?.nom ?? ''
    }
    return state?.selectedPiecesFromVehicle[0]?.typePiece?.nom ?? ''
  })

  const [referenceConstValue, setReferenceConstValue] = useState<any>(
    state?.selectedPiecesFromVehicle[0]?.referenceConstructeur ?? ''
  )

  const [showFilter, setShowFilter] = useState<boolean>(true)
  const [formattedCodePiece, setFormattedCodePiece] = useState('')

  const [pieceSelected, setPieceSelected] = useState<any>(null)
  const [pieces, setPieces] = useState<any>([])
  const [clientDemandepieces, setClientDemandePieces] = useState<any>([])
  const [idClientDemandePiece, setIdClientDemandePiece] = useState<any>(state?.idDemandePiece)
  const [pieceRechercheSelected, setPieceRechercheSelected] = useState<any>(null)
  const [isAvailable, setIsAvailable] = useState<any>(state?.isAvailable)
  const [quantityPiece, setQuantityPiece] = useState<any>(state?.pieceQuantity)
  const [typePieceHn, setTypePieceHn] = useState<any>(() => {
    if (state?.isFromUrlFiltered) {
      return state?.typePieceHnFiltered ?? ''
    }
    return state?.selectedPiecesFromVehicle[0]?.typePieceHn ?? null
  })
  const [isHorsNomenclature, setIsHorsNomenclature] = useState<any>(state?.isHorsNomenclature)
  const [demandeClient, setDemandeClient] = useState<ModeleClientDemande | undefined>(
    state?.demandeClient
  )
  const [isAssign, setIsAssign] = useState<boolean>(false)
  const [tempClientId, setTempClientId] = useState<number | null>(null)
  const [defaultContact, setDefaultContact] = useState()
  const [isClientSociety, setIsClientSociety] = useState<boolean>(false)
  const [clientId, setClientId] = useState<any>(state?.clientId)
  const clientDataRef = useRef<ModeleClient | null>(state?.dataClientInfos)
  const demandeSourceValue = useState({
    value: state?.demandeClient?.demandeSource?.id,
    label: state?.demandeClient?.demandeSource?.name,
  })
  const [radioValue, setRadioValue] = useState<any>()
  const [defaultValueContact, setDefaultValueContact] = useState()
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false)
  const [contactedByDm, setContactedByDm] = useState<any | null>()
  const [contentCommunication, setContentCommunication] = useState<any>(state?.contentCommunication)
  const [data, setData] = useState<ModeleClient>(modeleClientInitValues)
  const [loadingCLientInfo, setLoadingCLientInfo] = useState(false)
  const [isProspect, setIsProspect] = useState<boolean>(false)
  const [otherData, setOtherData] = useState<ModeleClientOtherData>(modeleClientOtherDataInitValues)
  const [clientAdresses, setClientAdresses] = useState<any>(state?.clientAdresses)
  const [adresseFacturation, setAdresseFacturation] = useState<any>(state?.adresseFacturation)
  const [isConfirmEdit, setIsConfirmEdit] = useState(false)
  const [showMoreClientInfo, setShowMoreClientInfo] = useState<boolean>(false)
  const [piecePropData, setPiecePropData] = useState<any>([])
  const [checkedPieces, setCheckedPieces] = useState<number[]>([])
  const [totalLibelle, setTotalLibelle] = useState<number>(0)

  const valueMarqueRef = useRef<any>([])
  const valueModelRef = useRef<any>([])
  const [loadingDepot, setLoadingDepot] = useState<boolean>(false)
  const [adresseDepots, setAdresseDepots] = useState<Array<ModeleAdresseDepot>>([])

  // Adresse de facturation / livraison > Création / Modification depuis Fiche client
  const [clientAdresseData, setClientAdresseData] = useState<any>(null)
  const [clientAdresseEdit, setClientAdresseEdit] = useState<any>(null)
  const [refetchClientData, setRefetchClientData] = useState<boolean>(false)
  const [livraisonSelectedValue, setLivraisonSelectedValue] = useState({value: '', label: ''})
  const [facturationSelectedValue, setFacturationSelectedValue] = useState({value: '', label: ''})

  const abortController = useRef<AbortController | null>(null)

  const initialCodePiece = () => {
    if (state?.isFromUrlFiltered) {
      return state?.typePieceFiltered ? formatTypePieceSansNom(state.typePieceFiltered) : ''
    }
    return typePieceHn !== null
      ? ''
      : formatTypePieceSansNom(state?.selectedPiecesFromVehicle?.[0]?.typePiece)
  }

  const isVehiculeHorsType =
    state?.selectedPiecesFromVehicle?.[0]?.clientDemandeImmat?.vehiculeHorsType !== null &&
    state?.selectedPiecesFromVehicle?.[0]?.clientDemandeImmat?.vehiculeHorsType !== undefined

  const [searchPage, setSearchPage] = useState<any>(null)

  const [selectedProvenance, setSelectedProvenance] = useState<any>({value: '', label: ''})
  const [pieceToValidate, setPieceToValidate] = useState(null)
  const {currentUser} = useAuth()
  const [updatedAdresseLivInfo, setUpdatedAdresseLivInfo] = useState({
    id: state?.updatedAdresseLivInfo?.id,
    adresseLiv: state?.updatedAdresseLivInfo?.adresseLiv,
    complementAdresseLiv: state?.updatedAdresseLivInfo?.complementAdresseLiv,
    telephoneLiv: state?.updatedAdresseLivInfo?.telephoneLiv,
    cPLiv: state?.updatedAdresseLivInfo?.cPLiv,
    villeLiv: state?.updatedAdresseLivInfo?.villeLiv,
    paysLiv: state?.updatedAdresseLivInfo?.paysLiv,
  })
  const [updatedAdresseFactInfo, setUpdatedAdresseFactInfo] = useState({
    id: state?.updatedAdresseFactInfo?.id,
    adresseFac: state?.updatedAdresseFactInfo?.adresseFac,
    complementAdresseFac: state?.updatedAdresseFactInfo?.complementAdresseFac,
    telephoneFac: state?.updatedAdresseFactInfo?.telephoneFac,
    cPFac: state?.updatedAdresseFactInfo?.cPFac,
    villeFac: state?.updatedAdresseFactInfo?.villeFac,
    paysFac: state?.updatedAdresseFactInfo?.paysFac,
  })
  const [updatedFinalAdresseLivInfo, setUpdatedFinalAdresseLivInfo] = useState({
    id: state?.updatedFinalAdresseLivInfo?.id,
    adresseLiv: state?.updatedFinalAdresseLivInfo?.adresseLiv,
    complementAdresseLiv: state?.updatedFinalAdresseLivInfo?.complementAdresseLiv,
    telephoneLiv: state?.updatedFinalAdresseLivInfo?.telephoneLiv,
    cPLiv: state?.updatedFinalAdresseLivInfo?.cPLiv,
    villeLiv: state?.updatedFinalAdresseLivInfo?.villeLiv,
    paysLiv: state?.updatedFinalAdresseLivInfo?.paysLiv,
  })
  const [updatedFinalAdresseFactInfo, setUpdatedFinalAdresseFactInfo] = useState({
    id: state?.updatedFinalAdresseFactInfo?.id,
    adresseFac: state?.updatedFinalAdresseFactInfo?.adresseFac,
    complementAdresseFac: state?.updatedFinalAdresseFactInfo?.complementAdresseFac,
    telephoneFac: state?.updatedFinalAdresseFactInfo?.telephoneFac,
    cPFac: state?.updatedFinalAdresseFactInfo?.cPFac,
    villeFac: state?.updatedFinalAdresseFactInfo?.villeFac,
    paysFac: state?.updatedFinalAdresseFactInfo?.paysFac,
  })
  const [isAdresseUpdated, setIsAdresseUpdated] = useState<boolean>(
    state?.isAdresseUpdated ? state?.isAdresseUpdated : false
  )
  const [errorsFac, setErrorsFac] = useState(state?.errorsFac)
  const [errorsLiv, setErrorsLIv] = useState(state?.errorsLiv)
  const [isCreateViaModal, setIsCreateViaModal] = useState<boolean>(false)
  const [openModalResVeh, setOpenModalResVeh] = useState<boolean>(false)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [tempClient, setTempClient] = useState<any | null>(null)
  const [contactedByBloc, setContactedByBloc] = useState<any>(state?.contactedByBloc)
  const [contactedBy, setContactedBy] = useState<any>(state?.contactedBy)
  const [provenances, setProvenances] = useState<any>([])
  const [isLoadingProvenance, setIsLoadingProvenance] = useState<boolean>(false)
  const [isPrevious, setIsPrevious] = useState<boolean>(true)
  const [searchTerm, setSearchTerm] = useState(locationState?.searchTerm ?? '')
  const [loadingPanier, setLoadingPanier] = useState(false)

  const [sortField, setSortField] = useState<string>('')
  const [sortOrder, setSortOrder] = useState<string>('')
  const [piecePubliable, setPiecePubliable] = useState<boolean>(true)
  const [loadingAdresse, setLoadingAdresse] = useState<boolean>(false)
  const [retraitDepot, setRetraitDepot] = useState<boolean>(
    state?.retraitDepot ?? state?.demandeClient?.retraitDepot ?? false
  )
  const [commentaireInterne, setCommentaireInterne] = useState<string>(
    state?.commentaireInterne ?? state?.demandeClient?.commentaireInterne ?? ''
  )
  const [initialPieces, setInitialPieces] = useState<any[]>([])

  const [isEditPanier, setIsEditPanier] = useState<boolean>(false)
  const [isEditPiece, setIsEditPiece] = useState<boolean>(false)
  const [images, setImages] = useState<FileWithPreview[]>(state?.imagesDemandePj ?? []) // PJ demande

  const {
    selectedPOTAriane,
    setStatut,
    setEtape,
    setPanierAriane,
    setDemandeAriane,
    resetFilAriane,
    setSelectedPOTAriane,
  } = useFilAriane()
  const [objectSearch, setObjectSearch] = useState<any>(null)
  const [idClientDmdPieceDemonter, setIdClientDmdPieceDemonter] = useState<any>(null)
  const [selectedPieceRecherche, setSelectedPieceRecherche] = useState<any>(null)
  const [reloadLibelle, setReloadLibelle] = useState<boolean>(false)
  const [clientContacts, setClientContacts] = useState<ModeleClientContact[]>([])
  const [pieceInstance, setPieceInstance] = useState<string|null>(null);
  const [showDestination, setShowDestination] = useState<boolean>(false)

  const getDemandeProp = useCallback(() => {
    setLoadingPanier(true)
    getDemandeProposee(state?.demandeId).then((clientDemandeProp) => {
      if (clientDemandeProp?.status == 200 && clientDemandeProp?.data != undefined) {
        const finalPanier = clientDemandeProp?.data?.map((piece) => {
          // TVA POT toujours 20%
          const isProfessionnel = piece?.isTypePiecePOT
            ? 20
            : state?.dataClientInfos && state?.dataClientInfos?.professionnel === false
            ? 10
            : 20

          const pieceExclue = !!state?.dataClientInfos?.sauf?.some(
            (item) => item.label === piece.nomTypePieceProposee
          )
          const fraisOffert = !!state?.dataClientInfos?.fraisPortOffert && !pieceExclue
          const fraisDePort = fraisOffert || retraitDepot ? 0 : Number(piece?.fraisDePort)

          const taux = Number(piece?.tauxRemise ?? 0)
          const tauxTva = Number(piece?.tauxTva ?? 0)
          const prix = Number(piece.prix ?? 0)

          const prixReferentielTtc = Number(prix * (1 + tauxTva / 100)) ?? 0
          const prixReferentielHtInitial =
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ?? 0
          const prixReferentielHt =
            Number(piece?.prixReferentiel) ??
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ??
            0

          const prixVenteProposeeHt =
            Number(prixReferentielHt - prixReferentielHt * (taux / 100)) ?? 0
          const prixVenteProposeeTtc =
            Number(prixVenteProposeeHt * (1 + isProfessionnel / 100)) ?? 0
          const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

          return {
            ...piece,
            tauxRemise: Number(taux?.toFixed(1)),
            fraisDePort: Number(fraisDePort?.toFixed(2)),
            montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
            prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
            prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
            prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
            prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
            prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
          }
        })
        setPanier(finalPanier)
        // setPanierFiltered(finalPanier)

        if (finalPanier && initialPieces.length === 0) {
          const copieInitiale = finalPanier
            .filter((p) => p.statut === 'PROPO')
            .map((p) => {
              return {
                id: p.id,
                tauxRemise: Number(p?.tauxRemise ?? 0),
                montantRemise: Number(p?.montantRemise ?? 0),
                fraisDePort: Number(p.fraisDePort ?? 0),
                fraisDePortInitial: Number(p.fraisDePort ?? 0),
                prixReferentielHt: Number(p?.prixReferentielHt ?? 0),
                prixReferentielTtc: Number(p?.prixReferentielTtc ?? 0),
                prixVenteProposeeHt: Number(p?.prixVenteProposeeHt ?? 0),
                prixVenteProposeeTtc: Number(p?.prixVenteProposeeTtc ?? 0),
              }
            })
          setInitialPieces(copieInitiale)
        }

        setLoadingPanier(false)
      }
    })
  }, [state?.demandeId])

  const getDemande = useCallback(() => {
    let centreIds: string | undefined = ''
    if (currentUser) {
      let userCentre = currentUser?.listeCentres?.[0]
      if (userCentre?.length > 0) {
        centreIds = userCentre?.map((centre) => centre?.id)?.join(',')
      }
    }

    getClientDemandeImmat(state?.demandeId, centreIds).then((clientDemandeReq) => {
      if (clientDemandeReq?.status == 200 && clientDemandeReq?.data != undefined) {
        setClientDemandePieces(clientDemandeReq.data.clientDemandePiece)
        setDemandeClient(clientDemandeReq.data.demande)
      }
    })
  }, [state?.demandeId])

  useEffect(
    function refetchData() {
      if (state?.demandeId && state?.dataClientInfos) {
        getDemandeProp()
        getDemande()

        // Récuperation des contacts du client
        getClientContacts(state?.clientId).then((res) => {
          if (res?.status === 200 && res?.data !== undefined) {
            setClientContacts(res?.data)
          }
        })
      }
    },
    [state?.demandeId, state?.dataClientInfos]
  )

  useEffect(() => {
    if (panier?.length > 0) setPanierAriane(panier)
    if (demandeClient) setDemandeAriane(demandeClient)
    else resetFilAriane()

    const etape = demandeClient?.clientDemandeEtape?.code
    if (!etape) return

    setEtape(etape)

    if (demandeClient?.intervention) setStatut('INTERVENTION')
    else if (etape === 'REFUS') setStatut('REFUSE')
    else if (etape === 'BLOQU') setStatut('ACCEPTEE BLOQUE')
    else if (etape === 'MODIF') setStatut('MODIFIEE')
    else if (etape === 'ECHEC') setStatut('ACCEPTEE INDISPONIBLE')
    else if (etape === 'INDIS') setStatut('INDISPONIBLE')
    else setStatut('')
  }, [panier, demandeClient])

  // Mise a jour des données selectedPiecesFromVehicle en state
  useEffect(() => {
    if (clientDemandepieces?.length > 0) {
      const filteredPiece = clientDemandepieces.filter((item) =>
        state?.selectedPiecesFromVehicle
          ?.map((piecesSelected) => piecesSelected?.id)
          .includes(item.id)
      )
      setPieces(filteredPiece)
      if (!pieceInstance) setPieceInstance(`${filteredPiece?.[0]?.id}_1`)
      const key = selectedPieceRecherche
        ? filteredPiece.findIndex((piece) => piece.id === selectedPieceRecherche.id)
        : 0
      setPieceRechercheSelected(filteredPiece?.[key])
      setIsAvailable(!(filteredPiece?.[key]?.statut === 'NON_DISPONIBLE'))
    } else {
      setPieces(state?.selectedPiecesFromVehicle)
      if (!pieceInstance) setPieceInstance(`${state?.selectedPiecesFromVehicle?.[0]?.id}_1`)
    }
  }, [state?.selectedPiecesFromVehicle, clientDemandepieces, pieceInstance])

  const showToastPOT = () => {
    toast.success(
      `Pièce d'occasion taxable ${pieceSelected ? 'ajoutée' : 'modifiée'} avec succès.`,
      {
        hideProgressBar: true,
        autoClose: 2000,
      }
    )
  }

  // filtrer les données de modèle apres selection de marque
  useEffect(() => {
    if (valueMarque?.length > 0 && allModeleVehicule?.length > 0) {
      const filteredModele = allModeleVehicule.filter((vehicule) =>
        valueMarque.some((item) => vehicule?.marque === item.marque)
      )
      filteredModele && setModeleVehicule(filteredModele)
    }
  }, [valueMarque, allMarqueVehicule, allModeleVehicule])

  // Pour compter le nombre de requête exécutée pour le chargement de lot
  const handleCount = () => {
    setCounter((count) => count + 1)
  }

  // Supprimer les "//" et mettre le texte en Abcdef
  const formatTexte = (str: string): string => {
    if (!str) return ''
    const result = str
      .replace(/\\r\\n|\r?\n|\\/g, ',') // retours ligne et backslashes → virgule
      .split(',') // découper sur virgule
      .map((s) => s.trim()) // enlever espaces
      .filter(Boolean) // supprimer morceaux vides
      .join(', ') // reconstruire avec virgule + espace

    return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase()
  }

  const showDetailDemontage = (piece: any) => {
    setIdClientDmdPieceDemonter(piece?.id)
    const searchRef = {
      reference: '',
      codePiece: piece?.typePieceHn !== null ? '' : formatTypePieceSansNom(piece?.typePiece), // code type pièce
      codeVehicule: piece?.demandeDemontage?.vehicule?.numero, // numero de véhicule
      marque: '',
      modele: '',
      codeMoteur: '',
      immatriculation: '',
    }

    setObjectSearch({
      nomPiece: piece?.typePiece?.nom,
      idTypePiece: piece?.typePiece?.id,
      page: !isSearch ? currentPage : 1,
      refereSearch: searchRef,
      marque:
        state?.selectedPiecesFromVehicle[0]?.clientDemandeImmat?.vehiculeHorsType !== null
          ? ''
          : state?.selectedPiecesFromVehicle[0]?.marque,
      model:
        state?.selectedPiecesFromVehicle[0]?.clientDemandeImmat?.vehiculeHorsType !== null
          ? ''
          : state?.selectedPiecesFromVehicle[0]?.modele,
      isAgregate: true,
      clientId: locationState?.selectedPiecesFromVehicle[0]?.demande?.id,
      sortField: sortField,
      sortOrder: sortOrder,
      piecePubliable: false,
      idPieceProposee: piece?.clientDemandePieceProposee[0]?.id,
      idDemande: piece?.demande?.id,
    })
  }

  // Fonction pour ouvrir le modal et définir la donnée à afficher
  const showDetail = (piece: any) => {
    setDataToDisplayVoirToutes({
      ...piece,
      fromListPieceStock: true, // on ajoute un flag
      idClientDemandePiece: idClientDemandePiece,
      quantityPiece: quantityPiece,
    })
  }
  // Fonction pour générer les props du td
  const modalTdProps = (piece: any) => ({
    'data-bs-target': '#modal_details_cat',
    'data-bs-toggle': 'modal',
    'data-bs-dismiss': 'modal',
    onClick: () => showDetail(piece),
  })

  useEffect(() => {
    setNomTP(locationState?.selectedPiecesFromVehicle[0]?.nomTP)
  }, [locationState])

  // Récupération de la demandeImmat puis de la liste des pièces
  useEffect(() => {
    const defaultSearch = {
      reference: '',
      codePiece: '',
      codeVehicule: '',
      marque: '',
      modele: '',
      codeMoteur: '',
      immatriculation: '',
    }
    if (searchPage) {
      const {isSearch, ...searchPageWithoutIsSearch} = searchPage
      if (JSON.stringify(searchPageWithoutIsSearch) !== JSON.stringify(defaultSearch)) {
        setLoading(true)
        getListePieces(showTable)
        getOneDemImmat()
      } else {
        toast.info(
          'Recherche trop large. Veuillez renseigner au moins une marque, un modèle ou une référence OE...'
        )
      }
    }
  }, [params.demImmat, currentPage, searchPage, showTable, sortField, sortOrder])

  // Récupération des données utiles à l'assistance AI
  const getOneDemImmat = () => {
    getOneDemandeImmat(params.demImmat).then((res) => {
      if (res && res.status === 200 && res.data) {
        // Récupération du nom de type pièce
        let nomTypePiece: any = []

        // nomTypePiece = res.data.clientDemande.pieces.filter(
        //   (item) => item.typePiece.id == idTypePiece
        // )

        nomTypePiece = res.data.clientDemande.pieces.filter(
          (item) => item?.id == locationState?.selectedPiecesFromVehicle[0]?.id
        )
        if (nomTypePiece.length > 0)
          setNomTP(
            nomTypePiece[0].typePieceHn
              ? nomTypePiece[0].typePieceHn
              : nomTypePiece[0].typePiece.nom
          )

        // Récupération des détails du véhicule
        let natVehicle = res.data?.modele
          ? 'modele'
          : res.data?.vehiculeHorsType
          ? 'VHT'
          : 'immatriculation'
        setMarqueV(
          natVehicle === 'modele'
            ? res.data?.modele?.marque.nom
            : natVehicle === 'VHT'
            ? res.data?.vehiculeHorsType?.marque
            : res.data?.donneesImmatriculation?.stecMarque ??
              res.data?.donneesImmatriculation?.smarque
        )
        setModeleV(
          natVehicle === 'modele'
            ? res.data?.modele?.nom
            : natVehicle === 'VHT'
            ? res.data?.vehiculeHorsType?.nom
            : res.data?.donneesImmatriculation?.stecModele ??
              res.data?.donneesImmatriculation?.smodele
        )
        setVersionV(
          natVehicle === 'immatriculation' ? res.data.donneesImmatriculation?.sversion : ''
        )
        setVinV(natVehicle === 'immatriculation' ? res.data.donneesImmatriculation?.sVin : '')
        setEnergieV(
          natVehicle === 'immatriculation' ? res.data.donneesImmatriculation?.senergie : ''
        )
        setNumSerieV(
          natVehicle === 'immatriculation' ? res.data.donneesImmatriculation?.snoSerie : ''
        )
        setDatePremCircV(
          natVehicle === 'immatriculation'
            ? moment(res.data.donneesImmatriculation?.sdatePme, 'YYYYMMDD').format('DD/MM/YYYY')
            : natVehicle === 'VHT'
            ? res.data.vehiculeHorType?.debutPhase
              ? moment(res.data.vehiculeHorType?.debutPhase, 'YYYYMMDD').format('DD/MM/YYYY')
              : ''
            : res.data.vehiculeModele?.debutPhase
            ? moment(res.data.vehiculeModele?.debutPhase, 'YYYYMMDD').format('DD/MM/YYYY')
            : ''
        )
      }
    })
  }

  // Pour lister les pièces
  const getListePieces = (isAgregate = true) => {
    setLoading(true)
    getListePieceViaType(
      idTypePiece ?? 'horsNomenclature',
      !isSearch ? currentPage : 1,
      searchPage,
      state?.selectedPiecesFromVehicle[0]?.clientDemandeImmat?.vehiculeHorsType !== null
        ? ''
        : state?.selectedPiecesFromVehicle[0]?.marque,
      state?.selectedPiecesFromVehicle[0]?.clientDemandeImmat?.vehiculeHorsType !== null
        ? ''
        : state?.selectedPiecesFromVehicle[0]?.modele,
      isAgregate,
      locationState?.selectedPiecesFromVehicle[0]?.demande?.id,
      sortField,
      sortOrder,
      piecePubliable
    ).then((response) => {
      if (response?.data !== undefined) {
        setNombreDePages(response?.pages)
        setTotalPages(response?.total)
        setCurrentPage(response?.page)
        setListPieceArr(response?.data)
        // setTauxRemise(response?.tauxRemise)
        setPrixTransport(response?.prix_transport)
        checkPieceAvailable(response?.data)
        setCounter(0)
        setActivePieces([])
        setShowDestination(!piecePubliable)
        setIsSearch(false)
        setLoading(false)
      }
    })
  }

  const checkPieceAvailable = (listPiecesArr) => {
    if (listPiecesArr.length === 0) setIsNotAvailable(true)
  }

  const formik = useFormik({
    initialValues: {
      reference: state?.selectedPiecesFromVehicle[0]?.referenceConstructeur ?? '',
      codePiece: initialCodePiece(),
      codeVehicule: '',
      marque: valueMarque?.value ? state?.selectedPiecesFromVehicle[0]?.marque : '',
      modele: valueModele?.value ? state?.selectedPiecesFromVehicle[0]?.modele : '',
      codeMoteur: '',
      immatriculation: '',
      isSearch: false,
    },
    onSubmit: (values: any, {setSubmitting}) => {
      setSearchPage({
        reference: values.reference,
        codePiece:
          formattedCodePiece === ''
            ? searchValue === ''
              ? ''
              : initialCodePiece()
            : formattedCodePiece,
        codeVehicule: values.codeVehicule,
        marque: valueMarque?.value ?? values?.marque,
        modele: valueModele?.value ?? values?.modele,
        codeMoteur: values.codeMoteur,
        immatriculation: values.immatriculation,
        isSearch: true,
      })
    },
  })

  // Charger le positionnement sur le marché par lot de 5
  const itemsPerBatch = 5

  // Gestion des lots
  const handleLoadNextBatch = async () => {
    if (isLoading) return

    setIsLoading(true)
    let batchStart = activePieces.length
    let batchEnd = Math.min(batchStart + itemsPerBatch, listPiecesArr.length)

    if (batchStart >= listPiecesArr.length) {
      setIsLoading(false)
      return
    }

    // Ajout des nouveaux indices dans le nouveau lot
    const newActivePieces: any = []

    for (let i = batchStart; i < batchEnd; i++) {
      newActivePieces.push(i)
    }

    setActivePieces((prevActive) => [...prevActive, ...newActivePieces])

    let requestsInProgress = newActivePieces.length

    await Promise.all(
      newActivePieces.map(async (index) => {
        await new Promise((resolve) => setTimeout(resolve, 5))
        requestsInProgress -= 1
        if (requestsInProgress === 0) {
          setIsLoading(false)
        }
      })
    )
  }

  useEffect(() => {
    if (
      counter == activePieces.length ||
      (listPiecesArr.length > 0 &&
        activePieces.length === 0 &&
        activePieces.length < listPiecesArr.length)
    ) {
      handleLoadNextBatch()
    }
  }, [listPiecesArr, counter])

  const getAllProvenancePiece = () => {
    setIsLoadingProvenance(true)
    getProvenancePiece().then((res) => {
      if (res.status === 200 && res.data) {
        const transformedData = res.data.map((item) => ({
          value: item.id,
          label: item.libelle,
        }))
        setProvenances([...transformedData])
        setIsLoadingProvenance(false)
      } else {
        console.error('Erreur lors de la récupération des données')
        setIsLoadingProvenance(false)
      }
    })
  }

  // Récupération des provenances de pièce
  useEffect(function fetchProvenance() {
    getAllProvenancePiece()
  }, [])

  // Validation après sélection au panier
  const validateAddToPanier = async (piece) => {
    const idToast = toast.loading('Ajout en cours...')
    try {
      const response = await addPieceProp(
        idClientDemandePiece,
        piece.id,
        state?.dataClientInfos?.id,
        currentUser?.id,
        selectedProvenance,
        state?.demandeId,
        pieceInstance
      )
      const demPiece = response.data

      const clientDemande = demPiece?.clientDemandePiece?.demande
      setDemandeClient(clientDemande)

      setPanier((prevPanier: any[]) => {
        const exist = prevPanier.some((item) => item.id === piece.id)

        if (exist) {
          // Supprime si déjà présent
          return prevPanier.filter((item) => item.id !== piece.id)
        } else {
          const codePiece =
            piece.piece.typePiece?.sousCategorie.categorie.code +
            piece.piece.typePiece?.sousCategorie.code +
            piece.piece.typePiece?.code

          const client = clientDataRef.current
          const isProfessionnel = client && client?.professionnel === false ? 10 : 20
          const pieceExclue = !!client?.sauf?.some(
            (item) => item.label === piece?.piece?.typePiece?.nom
          )
          const fraisOffert = !!client?.fraisPortOffert && !pieceExclue
          const fraisDePort =
            fraisOffert || retraitDepot
              ? 0
              : piecePropData?.find((p) => p.id === piece.idPiecePropose)?.prixTransport ??
                piece?.prixTransport
          const fraisPortPieceEntre =
            piecePropData?.find((p) => p.id === piece.idPiecePropose)?.prixTransport ??
            piece?.prixTransport

          const taux = Number(client?.tauxRemise ?? 0)
          const tauxTva = Number(piece?.tauxTva ?? 0)
          const prix = Number(piece?.prix ?? 0)

          const prixReferentielTtc = Number(prix * (1 + tauxTva / 100)) ?? 0
          const prixReferentielHtInitial =
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ?? 0
          const prixReferentielHt = Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ?? 0

          const prixVenteProposeeHt =
            Number(prixReferentielHt - prixReferentielHt * (taux / 100)) ?? 0
          const prixVenteProposeeTtc =
            Number(prixVenteProposeeHt * (1 + isProfessionnel / 100)) ?? 0
          const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

          //  Calcul Nombre de jours stockage
          const now = new Date()
          const stockageDate = new Date(piece.stockageDate)

          now.setHours(0, 0, 0, 0)
          stockageDate.setHours(0, 0, 0, 0)

          const tempNbrJourStockageMs = stockageDate.getTime() - now.getTime()
          const diffDays = Math.abs(Math.floor(tempNbrJourStockageMs / (1000 * 60 * 60 * 24)))

          const provenancePanier = provenances.find((prov) => prov.value === selectedProvenance)

          // transformer label en libellé pour l'afficher temporairement dans le panier'
          const transformedProvenanceData = {
            value: provenancePanier?.value,
            libelle: provenancePanier?.label,
          }
          // Mauvais données dans state?.piece?.typePiece?.nom
          return [
            ...prevPanier,
            {
              id: piece.id,
              refConstructeur: piece.piece.referenceConstructeur,
              statut: 'A_PROPO',
              etat: piece.etat.libelle,
              refCasier: piece.stockageBac || piece?.stockageAllee,
              // marque: state?.marque,
              // modele: state?.modele,
              marque: state?.selectedPiecesFromVehicle[0]?.marque,
              modele: state?.selectedPiecesFromVehicle[0]?.modele,
              marquePiece: piece.vehiculeEntre?.vehicule?.modele?.marque?.nom,
              modelePiece: piece.vehiculeEntre?.vehicule?.modele?.nom,
              nomTypePiece: typePieceHn ? null : piece?.piece?.typePiece?.nom,
              nomTypePieceHN: typePieceHn,
              nomTypePieceProposee: piece?.piece?.typePiece?.nom,
              idTypePiece: state?.idTypePiece ?? piece.piece.typePiece.id,
              // immat:
              //   state?.isViaModele || state?.isHorsType
              //     ? `${state?.selectedPiecesFromVehicle[0]?.marque} - ${state?.selectedPiecesFromVehicle[0]?.modele}`
              //     : state?.immat ?? state?.immat,
              immat: state?.selectedPiecesFromVehicle[0]?.clientDemandeImmat?.immatriculation ?? '',
              isVHT: !!state?.selectedPiecesFromVehicle[0]?.clientDemandeImmat?.vehiculeHorsType,
              demandeImmatId: state?.demandeImmatId,
              codePiece: codePiece,
              pieceQuantity: quantityPiece,
              prix: piece.prix,
              tauxRemise: Number(taux?.toFixed(1)),
              tauxTva: Number(tauxTva?.toFixed(2)),
              fraisDePort: Number(fraisDePort?.toFixed(2)),
              fraisDePortInitial: Number((demPiece?.pieceEntre?.prixTransport ?? 0)?.toFixed(2)),
              fraisPortPieceEntre: fraisPortPieceEntre,
              montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
              prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
              prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
              prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
              prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
              prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
              idPiecePropose: demPiece?.id ?? demPiece?.idPiecePropose,
              idTypePiecePropose: piece?.piece?.typePiece?.id,
              idRetraitDepot: null,
              nomRetraitDepot: null,
              isProposed: demPiece?.isProposed,
              idCLientDemandePiece: demPiece?.clientDemandePiece?.id,
              immatriculationNonTrouvee: state?.immatriculationNonTrouvee ?? null,
              kilometrage: piece.vehiculeEntre?.km,
              commentaires: piece.commentaire,
              nbrJourStockage: diffDays,
              dateStockage: piece.stockageDate,
              referencePiece: codePiece,
              datePremiereImmat: piece.vehiculeEntre.datePremiereImmat,
              prixConstructeur: piece.piece?.prixConstructeur,
              codePieceEntree: piece.code,
              idPieceEntre: piece.id ?? null,
              isTypePiecePOT: false,
              isDemontage: false,
              isAccepted: demPiece?.isAccepted,
              isAcceptedBlocked: demPiece?.isAcceptedBlocked,
              isQuantityReached: false,
              provenance: transformedProvenanceData,
              vin:
                state?.selectedPiecesFromVehicle[0]?.clientDemandeImmat?.donneesImmatriculation
                  ?.sVin ?? '',
              cnit: piece.vehiculeEntre?.vehicule?.cnit ?? '',
              images: demPiece?.pieceEntre?.images?.map((item: any) => item?.image),
              prixAchatPot: null,
              potObj: null,
              dateAcceptation: null,
              dateRefus: null,
              pieceInstance: pieceInstance,
            },
          ]
        }
      })
      toast.update(idToast, {
        render: 'Pièce ajoutée avec succès !',
        type: 'success',
        isLoading: false,
        autoClose: 2000,
      })
      // Reset valeur de la pièce & provenance sélectionnée
      setPieceToValidate(null)
      setSelectedProvenance({value: '', label: ''})
      setReloadLibelle(true)
    } catch (err) {
      toast.update(idToast, {
        render: "Erreur lors de l'ajout !",
        type: 'error',
        isLoading: false,
        autoClose: 2000,
      })
      // Reset valeur de la pièce & provenance sélectionnée
      setPieceToValidate(null)
      setSelectedProvenance({value: '', label: ''})
    }
  }

  const renderFormRowPieces = (showTable) => {
    return listPiecesArr.map((piece, index) => {
      let codeSousCat = piece[0]?.typePiece?.sousCategorie.code
      let codeCat = piece[0]?.typePiece?.sousCategorie.categorie.code
      let prixVenteMin = piece.prixVenteMin
      let prixVenteMax = piece.prixVenteMax
      let prixVenteTTC = Number(
        Number(Number(piece?.prix) * (1 + Number(piece?.tauxTva) / 100))?.toFixed(2) ?? 0
      )

      const getDayDiff = (date: Date) => {
        const now = new Date()
        const diff = now.getTime() - date.getTime()
        return Math.round(diff / (1000 * 60 * 60 * 24))
      }

      return (
        <tr key={index}>
          {showTable ? (
            <>
              {/*<td></td>*/}
              <td className='cursor-pointer'>
                <div className='d-flex align-items-center' style={{width: 'max-content'}}>
                  <div className='symbol symbol-45px me-5'>
                    {piece?.images[0]?.image &&
                    piece?.images[0]?.image != null &&
                    piece?.images[0]?.image !== 'NULL' ? (
                      <img
                        src={`https://koena.fr/photos/pieces/` + piece?.images[0]?.image}
                        alt={piece?.piece?.typePiece?.nom}
                        {...modalTdProps(piece)}
                      />
                    ) : (
                      <div {...modalTdProps(piece)}>
                        <ImgPieceBlank width={45} height={45} />
                      </div>
                    )}
                  </div>
                  <div className='d-flex justify-content-start flex-column'>
                    <span {...modalTdProps(piece)}>{piece?.piece?.typePiece?.nom}</span>
                    <span className='d-flex text-muted fw-semibold text-muted d-block fs-7 align-items-center'>
                      <span className={'me-1'}>{piece?.code + ' '}</span>
                      {piece?.code &&
                        (checkCopy !== piece?.code ? (
                          <i
                            className='ki-duotone ki-copy cursor-pointer fs-2'
                            onClick={(e) => handleCopie(piece?.code, e)}
                          ></i>
                        ) : (
                          <i className='ki-duotone ki-copy-success fs-2'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                          </i>
                        ))}
                    </span>
                  </div>
                </div>
              </td>
              <td>
                <div className='d-flex justify-content-start flex-column'>
                  <span className='fw-bold'>
                    {piece?.vehiculeEntre?.vehicule?.modele?.marque?.nom}
                  </span>
                  <span>{piece?.vehiculeEntre?.vehicule?.modele?.nom}</span>
                </div>
              </td>
              <td className='text-hover-primary cursor-pointer'>
                <div className='d-flex gap-2'>
                  <span {...modalTdProps(piece)}>
                    {piece?.vehiculeEntre?.numero + ' ' ?? 'N/C'}
                  </span>
                  <span>
                    {piece?.vehiculeEntre?.numero &&
                      (checkCopy !== piece?.vehiculeEntre?.numero ? (
                        <i
                          className='ki-duotone ki-copy cursor-pointer fs-2'
                          onClick={(e) => handleCopie(piece?.vehiculeEntre?.numero, e)}
                        ></i>
                      ) : (
                        <i className='ki-duotone ki-copy-success fs-2'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      ))}
                  </span>
                </div>
              </td>
              <td className='text-hover-primary cursor-pointer'>
                <div className='d-flex gap-2'>
                  <span {...modalTdProps(piece)}>
                    {piece?.piece?.referenceConstructeur + ' ' ?? 'N/C'}
                  </span>
                  <span>
                    {piece?.piece?.referenceConstructeur &&
                      (checkCopy !== piece?.piece?.referenceConstructeur ? (
                        <i
                          className='ki-duotone ki-copy cursor-pointer fs-2'
                          onClick={(e) => handleCopie(piece?.piece?.referenceConstructeur, e)}
                        ></i>
                      ) : (
                        <i className='ki-duotone ki-copy-success fs-2'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      ))}
                  </span>
                </div>
              </td>
              <td className='text-hover-primary cursor-pointer' {...modalTdProps(piece)}>
                {piece?.piece?.prixConstructeur}
              </td>
              <td className='text-hover-primary cursor-pointer' {...modalTdProps(piece)}>
                {prixVenteTTC ?? 'N/C'}
              </td>
              <td className='text-hover-primary cursor-pointer' {...modalTdProps(piece)}>
                {renderPieceStatus(piece?.etat?.libelle) ?? 'N/C'}
              </td>
              <td>
                {piece?.vehiculeEntre?.datePremiereImmat
                  ? moment(piece.vehiculeEntre.datePremiereImmat).format('DD/MM/YYYY')
                  : 'N/C'}
              </td>
              <td>
                <div className='d-flex justify-content-start flex-column'>
                  <p>{piece?.site?.code}</p>
                  <div className='d-flex gap-2'>
                    <span>
                      {piece?.stockageAllee ?? 'N/C'} - {piece?.stockageBac ?? 'N/C'}
                    </span>
                  </div>
                </div>
              </td>
              <td>{piece?.stockageDate ? getDayDiff(new Date(piece?.stockageDate)) : 'N/C'}</td>
              <td>{piece?.commentaire ? formatTexte(piece.commentaire) : 'N/C'}</td>
              {showDestination &&
                <td>{piece?.destination ?? 'N/C'}</td>
              }
              <td>
                <span className='d-flex align-items-center float-end' style={{gap: '10px'}}>
                  <AddToPanierButton
                    piece={piece}
                    state={state}
                    idTypePiece={idTypePiece}
                    detailVehicle={{
                      marque: state?.selectedPiecesFromVehicle[0]?.marque ?? '',
                      modele: state?.selectedPiecesFromVehicle[0]?.modele ?? '',
                    }}
                    isDetailPiece={false}
                    isListPieceStock={true}
                    tauxRemise={tauxRemise}
                    prixTransport={prixTransport}
                    idClientDemandePiece={idClientDemandePiece}
                    quantityPiece={quantityPiece}
                    setPieceToValidate={setPieceToValidate}
                    pieceToValidate={pieceToValidate}
                  />

                  <span
                    className={'btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'}
                  >
                    <i
                      className='bi bi-eye fs-2'
                      {...modalTdProps(piece)}
                      data-tooltip-id='tooltip'
                      data-tooltip-content='Détail Pièce'
                      data-tooltip-place='right'
                    />
                  </span>
                </span>
              </td>
            </>
          ) : (
            <>
              <td>
                {codeCat}
                {codeSousCat}
                {piece[0]?.typePiece?.code}
              </td>
              <td>{piece[0]?.typePiece?.nom}</td>
              <td>{piece[0]?.referenceConstructeur}</td>
              <td>{piece[0]?.prixConstructeur ? piece[0]?.prixConstructeur : 'N/C'}</td>
              <td>{piece[0]?.prixConstructeur ? prixVenteMin : 'N/C'}</td>
              <td>{piece[0]?.prixConstructeur ? prixVenteMax : 'N/C'}</td>
              <td>{piece.stock}</td>
              <td>
                {/* Pour gérer les lots */}
                {activePieces.includes(index) ? (
                  <OnMarket
                    reference={piece[0]?.referenceConstructeur}
                    piece={piece}
                    locationState={locationState}
                    index={index}
                    handleCount={handleCount}
                  />
                ) : (
                  <span className='badge bg-light text-gray-500'>Chargement...</span>
                )}
              </td>
              {showDestination && <td>{piece?.destination}</td>}
              <td>
                <div className='d-flex gap-2'>
                  <span
                    className='cursor-pointer'
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Assistance AI'
                    data-tooltip-place='right'
                    data-bs-target='#modalAI'
                    data-bs-toggle='modal'
                    data-bs-dismiss='modal'
                    onClick={() => getResultShowPiece(piece[0]?.referenceConstructeur)}
                  >
                    <i>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='32'
                        height='32'
                        viewBox='0 0 24 24'
                      >
                        <path
                          fill='#2c91a3'
                          fill-rule='evenodd'
                          d='M8.75 4a.75.75 0 0 0-1.5 0v1.25H7A1.75 1.75 0 0 0 5.25 7v.25H4a.75.75 0 0 0 0 1.5h1.25v2.5H4a.75.75 0 0 0 0 1.5h1.25v2.5H4a.75.75 0 0 0 0 1.5h1.25V17c0 .966.784 1.75 1.75 1.75h.25V20a.75.75 0 0 0 1.5 0v-1.25h2.5V20a.75.75 0 0 0 1.5 0v-1.25h2.5V20a.75.75 0 0 0 1.5 0v-1.25H17A1.75 1.75 0 0 0 18.75 17v-.25H20a.75.75 0 0 0 0-1.5h-1.25v-2.5H20a.75.75 0 0 0 0-1.5h-1.25v-2.5H20a.75.75 0 0 0 0-1.5h-1.25V7A1.75 1.75 0 0 0 17 5.25h-.25V4a.75.75 0 0 0-1.5 0v1.25h-2.5V4a.75.75 0 0 0-1.5 0v1.25h-2.5zm-2 3A.25.25 0 0 1 7 6.75h10a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25H7a.25.25 0 0 1-.25-.25zm5.049 7.753l-.275-.772H9.497l-.275.772a.75.75 0 0 1-1.413-.504l1.7-4.77l.003-.009l.004-.01c.152-.392.516-.711.994-.711c.479 0 .842.319.995.712l.003.009l.004.01l1.7 4.77a.75.75 0 0 1-1.413.503m-1.289-3.615l.479 1.343h-.958zm3.74-1.64a.75.75 0 0 1 1.5 0v5.003a.75.75 0 1 1-1.5 0z'
                          clip-rule='evenodd'
                        />
                      </svg>
                    </i>
                  </span>
                  {piece.stock !== 0 && (
                    <Link
                      to={`/demandes/pieceDetail/detail/${piece[0]?.id}`}
                      state={{filters: state?.filters}}
                      data-tooltip-id='tooltip'
                      data-tooltip-content='Détail de la pièce'
                      data-tooltip-place='right'
                    >
                      <img src='/media/svg/custom/info.svg' width={30} />
                    </Link>
                  )}
                </div>
              </td>
            </>
          )}
        </tr>
      )
    })
  }

  // Récupération des informations depuis OpenAI pour l'afficher dans le modal
  const getResultShowPiece = (refOE) => {
    setLoadingModalContent(true)
    getResultatAIPiece(
      nomTP,
      refOE,
      marqueV,
      modeleV,
      numSerieV,
      vinV,
      datePremCircV,
      energieV,
      versionV
    ).then((res) => {
      if (res && res.status === 200 && res.data) {
        setModalContent(res.data)
        setLoadingModalContent(false)
      }
    })
  }

  // Récupération les marques de vehicules
  const getMarqueVehiculeData = () => {
    return getMarqueVehicule()
      .then((marqueRequest) => {
        if (marqueRequest?.status === 200) {
          if (marqueRequest?.data !== undefined) {
            const transformedData = marqueRequest.data.map((item) => ({
              marque: item.id,
              value: item.nom,
              label: item.nom,
            }))
            setAllMarqueVehicule([...transformedData])
            setMarqueVehicule([...transformedData])
            const marqueExist = transformedData.find(
              (item) => item.value === state?.selectedPiecesFromVehicle[0]?.marque
            )
            valueMarqueRef.current = marqueExist
            marqueExist && setValueMarque(marqueExist)
          }
        }
      })
      .catch((e) => {
        console.error('erreur')
      })
  }

  // Récupération les modeles de vehicules
  const getModeleVehiculeData = () => {
    return getModeleVehicule()
      .then((modeleRequest) => {
        if (modeleRequest?.status === 200) {
          if (modeleRequest?.data !== undefined) {
            const transformedData = modeleRequest.data.map((item) => ({
              marque: item.idMarque,
              value: item.nom,
              label: item.nom,
            }))
            setAllModeleVehicule([...transformedData])
            setModeleVehicule([...transformedData])
            const modeleExist = transformedData.find(
              (item) => item.value === state?.selectedPiecesFromVehicle[0]?.modele
            )
            valueModelRef.current = modeleExist
            modeleExist && setValueModele(modeleExist)
          }
        }
      })
      .catch((e) => {
        console.error('erreur')
      })
  }

  //fonction qui set le searchPage après avoir eu les listes du marque et du modèle
  const searchPageValue = () => {
    let rst = {
      reference: state?.selectedPiecesFromVehicle[0]?.referenceConstructeur,
      codePiece: typePieceHn ? '' : initialCodePiece(),
      codeVehicule: '',
      marque: valueMarqueRef.current?.value ? state?.selectedPiecesFromVehicle?.[0]?.marque : '',
      modele: valueModelRef.current?.value ? state?.selectedPiecesFromVehicle?.[0]?.modele : '',
      codeMoteur: '',
      immatriculation: '',
    }
    setSearchPage(rst)
    return true
  }

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      await Promise.all([getMarqueVehiculeData(), getModeleVehiculeData()])
      searchPageValue()
    }
    init()

    const modal = modalRef.current
    if (modal) {
      modal.addEventListener('hidden.bs.modal', () => setModalContent(''))
    }
    return () => {
      if (modal) {
        modal.removeEventListener('hidden.bs.modal', () => {})
      }
    }
  }, [])

  // Style du select pour les filtres marque et modèle
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '45px',
      width: '100%',
      fontSize: '14px',
      backgroundColor: 'transparent',
    }),
  }

  const handleCopie = (text, e) => {
    e.stopPropagation()
    copyText(text, setCheckCopy, 500)
  }

  const renderFormRowImmat = () => {
    let selectedVehicleState = state?.selectedPiecesFromVehicle[0]
    return (
      <tr>
        <td>{selectedVehicleState?.marque}</td>
        <td>
          {selectedVehicleState?.modele} {state?.isHorsType && ' [VHT]'}
        </td>
        <td>
          <div className='d-flex gap-3 align-items-center'>
            {selectedVehicleState?.clientDemandeImmat?.immatriculation}
            {selectedVehicleState?.clientDemandeImmat?.immatriculation &&
              (checkCopy !== selectedVehicleState?.clientDemandeImmat?.immatriculation ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) =>
                    handleCopie(selectedVehicleState?.clientDemandeImmat?.immatriculation, e)
                  }
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </td>
        <td>
          <div className='d-flex gap-3 align-items-center'>
            {selectedVehicleState?.clientDemandeImmat?.donneesImmatriculation?.sVin}
            {selectedVehicleState?.clientDemandeImmat?.donneesImmatriculation?.sVin &&
              (checkCopy !==
              selectedVehicleState?.clientDemandeImmat?.donneesImmatriculation?.sVin ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) =>
                    handleCopie(
                      selectedVehicleState?.clientDemandeImmat?.donneesImmatriculation?.sVin,
                      e
                    )
                  }
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </td>
      </tr>
    )
  }

  //tri des elements sur le tableau ( par order croissant et decroissant )
  // const ascOrderFilter = (label: string, order: 'asc' | 'desc' = 'asc') => {
  //   if (!listPiecesArr?.length) return
  //
  //   const triConfig: Record<string, (item: any) => string | number | null> = {
  //     refConst: (item) => item.piece?.referenceConstructeur ?? null,
  //
  //     prixConst: (item) => Number(item.piece?.prixConstructeur ?? 0),
  //
  //     prixVente: (item) => Number(item.prix ?? 0),
  //
  //     etat: (item) => item.etat?.libelle ?? null,
  //
  //     dateCirculation: (item) =>
  //       item.vehiculeEntre?.datePremiereImmat
  //         ? new Date(item.vehiculeEntre.datePremiereImmat).getTime()
  //         : null,
  //
  //     refStockage: (item) => item.stockageBac ?? null,
  //
  //     dateStockage: (item) => (item.stockageDate ? new Date(item.stockageDate).getTime() : null),
  //
  //     commentaire: (item) => item.commentaire ?? null,
  //   }
  //
  //   const extractor = triConfig[label]
  //   if (!extractor) return
  //
  //   const sortedContent = [...listPiecesArr].sort((a, b) => {
  //     const valA = extractor(a)
  //     const valB = extractor(b)
  //
  //     if (valA == null) return 1
  //     if (valB == null) return -1
  //
  //     if (typeof valA === 'string' && typeof valB === 'string') {
  //       return order === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA)
  //     }
  //
  //     return order === 'asc' ? Number(valA) - Number(valB) : Number(valB) - Number(valA)
  //   })
  //
  //   setListPieceArr(sortedContent)
  // }

  type SortableHeaderProps = {
    title: string
    label: string
    textHover?: string
  }
  // affichage du tri sur le th du tableau "Filtres de recherches"
  const SortableHeader = ({title, label, textHover}: SortableHeaderProps) => {
    return (
      <div
          className='d-flex flex-row gap-2 align-items-center'
          data-tooltip-id='tooltip'
          data-tooltip-content={textHover}
          data-tooltip-place='bottom'
          style={{cursor: textHover ? 'pointer' : ''}}
      >
        <span>{title}</span>

        <div className='d-flex flex-column'>
          <i
            className={`bi bi-caret-up${
              sortField === label && sortOrder === 'ASC' ? '-fill' : ''
            } text-muted`}
            style={{cursor: 'pointer'}}
            onClick={() => {
              setSortField(label)
              setSortOrder('ASC')
            }}
          />
          <i
            className={`bi bi-caret-down${
              sortField === label && sortOrder === 'DESC' ? '-fill' : ''
            } text-muted`}
            style={{cursor: 'pointer'}}
            onClick={() => {
              setSortField(label)
              setSortOrder('DESC')
            }}
          />
        </div>
      </div>
    )
  }

  const currentSelectedPieceRef = useRef<any>(null)
  const selectedPiece = (pcs) => {
    setSelectedPieceRecherche(pcs)
    setPiecePubliable(true)
    if (pcs?.statut === 'NON_DISPONIBLE') {
      setIsAvailable(false)
    } else {
      setIsAvailable(true)
    }
    setQuantityPiece(pcs?.quantite)
    setIdClientDemandePiece(pcs?.id)
    setReferenceConstValue(pcs?.referenceConstructeur)

    if (pcs.typePiece) {
      setIdTypePiece(pcs.typePiece.id)
      setSearchValue(pcs?.typePiece?.nom)
      setSelectedSearchValue(pcs?.typePiece?.nom)
      setFormattedCodePiece(formatTypePieceSansNom(pcs?.typePiece))
      setTypePieceHn(null)
    } else {
      if (pcs?.typePieceHn) {
        setIdTypePiece(null)
        setSearchValue('')
        setSelectedSearchValue('')
        setIsHorsNomenclature(true)
        setTypePieceHn(pcs?.typePieceHn)
        setFormattedCodePiece('')
      }
    }

    const checkMarque = marqueVehicule.filter(
      (item) => item.value === state?.selectedPiecesFromVehicle[0]?.marque
    )
    const checkModele = modeleVehicule.filter(
      (item) => item.value === state?.selectedPiecesFromVehicle[0]?.modele
    )

    const mq = checkMarque.length > 0 ? checkMarque : ''
    const md = checkModele.length > 0 ? checkModele : ''

    let finalMarque: any
    let finalModele: any

    if (md == undefined || md == '') {
      finalModele = ''
    } else {
      finalModele = md[0]?.value
    }
    if (mq == undefined || mq == '') {
      finalMarque = ''
    } else {
      finalMarque = mq[0]?.value
    }

    setValueMarque(mq)
    setValueModele(md)

    formik.setFieldValue('marque', finalMarque)
    formik.setFieldValue('modele', finalModele)

    //quand on selectionne une pièce , effacer l'immatriculation, le code véhicule et la réference
    formik.setFieldValue('immatriculation', '')
    formik.setFieldValue('codeVehicule', '')

    if (currentSelectedPieceRef?.current && currentSelectedPieceRef?.current?.id === pcs?.id) return

    // Si pièce hors nomenclature alors ne rien mettre sur codePiece
    // Si VHT alors ne rien mettre sur marque et modele
    setSearchPage({
      reference: pcs?.referenceConstructeur,
      codePiece: pcs?.typePieceHn !== null ? '' : formatTypePieceSansNom(pcs?.typePiece),
      codeVehicule: '',
      marque: finalMarque,
      modele: finalModele,
      codeMoteur: '',
      immatriculation: '',
    })

    currentSelectedPieceRef.current = pcs
  }

  // Pour changer le statut de la pièce après avoir
  const handleStatusPieces = (id: number, status: boolean, envoiEmail: any) => {
    setPieces((prev) =>
      prev.map((p) =>
        p.id === id
          ? {
              ...p,
              envoiEmail: envoiEmail ?? null,
              statut: status ? null : 'NON_DISPONIBLE',
            }
          : p
      )
    )
    setClientDemandePieces((prev) =>
      prev.map((p) =>
        p.id === id
          ? {
              ...p,
              envoiEmail: envoiEmail ?? null,
              statut: status ? null : 'NON_DISPONIBLE',
            }
          : p
      )
    )
    setIsAvailable(status)
  }

  const updDemande = (stat: string, demande: ModeleClientDemande) => {
    // ne pas effacer stat
    setDemandeClient(demande)
  }

  const reactivePOT = async (piece) => {
    const demandePieceProposee = piece?.clientDemandePieceProposee

    const idPieceProposee = demandePieceProposee?.find(
      (item) => item.typePiecePOT !== null && item.dateAnnulation !== null
    )?.id

    if (!idPieceProposee) return

    const alertResult = await Swal.fire({
      title: 'Attention',
      text: 'Voulez-vous vraiment réactiver la POT ?',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    })

    if (!alertResult.isConfirmed) return

    const idToastValidate = toast.loading('Réactivation en cours...')

    try {
      const response = await activedPOT(idPieceProposee)

      if (response?.status === 200) {
        //mise à jour de la pièce concernée dans le panier
        setPanier((prev) =>
          prev?.map((item) => {
            if (item?.idPiecePropose === idPieceProposee) {
              return {
                ...item,
                dateAnnulation: null,
                statut: 'PROPO',
              }
            } else return item
          })
        )

        //mise à jours de la pièce ( client_demande_piece)
        setPieces((prev) =>
          prev.map((p) =>
            p.id === piece?.id
              ? {
                  ...p,
                  clientDemandePieceProposee: p.clientDemandePieceProposee?.map((cdpp) =>
                    cdpp.id === idPieceProposee
                      ? {
                          ...cdpp,
                          dateAnnulation: null,
                        }
                      : cdpp
                  ),
                }
              : p
          )
        )

        //mise à jour du state clientDemandePiece
        setClientDemandePieces((prev) =>
          prev.map((p) =>
            p.id === piece?.id
              ? {
                  ...p,
                  clientDemandePieceProposee: p.clientDemandePieceProposee?.map((cdpp) =>
                    cdpp.id === idPieceProposee
                      ? {
                          ...cdpp,
                          dateAnnulation: null,
                        }
                      : cdpp
                  ),
                }
              : p
          )
        )

        toast.update(idToastValidate, {
          render: 'Réactivation effectuée avec succès',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
      }
    } catch (err) {
      console.error('Erreur lors de la réactivation du POT', err)
      toast.update(idToastValidate, {
        render: 'Erreur lors de la réactivation du POT',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      })
    }
  }

  const renderTypePiece = () => {
    return (
      pieces?.length > 0 &&
      pieces?.map((pcs) => {
        const pieceInstances = panier
          ?.filter((item) => item?.idCLientDemandePiece === pcs?.id)
          ?.map((item) => item?.pieceInstance)

        const isDemandeDemontage =
          pcs?.demandeDemontage && pcs?.demandeDemontage?.statut?.code !== 'REFUS' ? true : false

        const isTypePiecePOT = pcs?.typePiecePOT?.length > 0

        // s' il y a déjà une POT dans le panier et que le statut est refusé ou acceptée échec => affichage du bouton ajout POT
        let createPOT = false
        const demandePieceProposee = pcs?.clientDemandePieceProposee
        //vérifier si toutes les POT sont annuller
        const potAnnuller = demandePieceProposee
          .filter((item) => item.typePiecePOT !== null)
          .every((item) => item.dateAnnulation !== null)

        if (demandePieceProposee?.length > 0) {
          let potRefusOrEchec = demandePieceProposee.some(
            (item) =>
              item.typePiecePOT !== null &&
              (item.isRefused === true || item.statut === 'REFUS' || item.dateEchec !== null)
          )

          let demontageRefus = demandePieceProposee.some(
            (item) =>
              item.demandeDemontageTypePiece !== null &&
              (item.isRefused === true || item.statut === 'REFUS')
          )

          if (potRefusOrEchec === true || demontageRefus === true || potAnnuller === true) {
            createPOT = true
          } else {
            createPOT = false
          }
        } else {
          createPOT = true
        }

        //vérification si la création d'une démande de démontages
        const isCreateDemontage =
          !pcs?.typePiecePOT?.length ||
          demandePieceProposee?.some(
            (item) =>
              item.typePiecePOT !== null &&
              (item.isRefused === true || item.statut === 'REFUS' || item.dateEchec !== null)
          ) ||
          potAnnuller === true

        // const isSelected = idTypePiece === pcs?.typePiece?.id
        let isSelected = false
        if (pcs?.typePiece) {
          if (idTypePiece === pcs?.typePiece?.id) {
            isSelected = true
          }
        } else {
          if (typePieceHn === pcs?.typePieceHn) {
            isSelected = true
          }
        }

        let backgroundColor = ''
        let borderColor = ''

        //envelope pour valider le panier
        let aValider = panier?.some(
          (item: any) => item.idCLientDemandePiece === pcs?.id && item.statut === 'A_PROPO'
          // && pcs?.clientDemandePieceProposee?.length > 0
        )

        let proposee = panier?.some(
          (item: any) => item.idCLientDemandePiece === pcs?.id && pcs?.proposee
        )
        if (isTypePiecePOT) {
          backgroundColor = '#ffeb85'
          borderColor = '#fffce6'
        } else if (isDemandeDemontage) {
          backgroundColor = '#aaf0bd'
          borderColor = '#e6ffed'
        } else if (aValider || proposee) {
          backgroundColor = '#50ad28'
          borderColor = '#e6ffed'
        } else {
          backgroundColor = '#fbfdf6'
          borderColor = '#f1f1f2'
        }

        if (pcs.statut) {
          backgroundColor = '#ffb200'
          borderColor = '#f6921e'
        }

        const getRgba = (hex, opacity) => {
          const r = parseInt(hex.slice(1, 3), 16)
          const g = parseInt(hex.slice(3, 5), 16)
          const b = parseInt(hex.slice(5, 7), 16)
          return `rgba(${r}, ${g}, ${b}, ${opacity})`
        }

        const haveImmat = !!pcs?.clientDemandeImmat?.immatriculation

        // Multiplication de la pièce à rechercher par la quandité demandée
        return Array.from({length: pcs?.quantite ?? 0}, (_, i) => (
          <div
            key={pcs?.typePiece?.id}
            className={`d-flex p-6 py-2 border ${
              isSelected && `${pcs?.id}_${i + 1}` === pieceInstance ? `border-primary` : ''
            } rounded justify-content-between align-items-center cursor-pointer`}
            onClick={() => {
              selectedPiece(pcs)
              setPieceInstance(`${pcs?.id}_${i + 1}`)
              formik.setFieldValue('reference', pcs?.referenceConstructeur ?? '')
            }}
            style={{
              height: '50px',
              backgroundColor: pieceInstances?.includes(`${pcs?.id}_${i + 1}`)
                ? getRgba(backgroundColor, 0.2)
                : undefined,
              borderColor: pieceInstances?.includes(`${pcs?.id}_${i + 1}`)
                ? borderColor
                : undefined,
            }}
          >
            <div className='d-flex gap-9'>
              <div className='fw-semibold'>
                {pcs?.typePiece ? pcs?.typePiece?.nom : pcs?.typePieceHn}
              </div>
              <div>{pcs?.typePieceHn ? '999999' : formatTypePieceSansNom(pcs?.typePiece)}</div>
              {pcs?.referenceConstructeur && <div>{pcs?.referenceConstructeur}</div>}
              <div className='text-gray-600'>
                {pcs?.marque && pcs?.modele ? `${pcs?.marque + '-' + pcs?.modele}` : ''}{' '}
                {pcs?.clientDemandeImmat?.vehiculeHorsType && ' [VHT]'}
              </div>
            </div>
            <div className='d-flex gap-3'>
              {aValider && (
                <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <img
                    src='/media/svg/custom/sendEmail.svg'
                    width='20'
                    className=''
                    style={{cursor: 'pointer'}}
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_1'
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Envoyer les suggestions au client'
                    data-tooltip-place='left'
                    alt='sendProposition'
                    onClick={(e) => e.stopPropagation()}
                  />
                </span>
              )}

              {/* début de la récativation de la pièce POT*/}
              {pcs?.typePiecePOT?.length > 0 && !createPOT && (
                <div>
                  <button
                    className='btn btn-bg-light btn-active-color-primary btn-sm'
                    data-bs-toggle='modal'
                    data-bs-target='#modalPOT'
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Modifier une pièce POT'
                    data-tooltip-place='left'
                    onClick={(e) => {
                      e.stopPropagation()
                      const lastIndex = pcs?.typePiecePOT.length - 1
                      //prendre le statut du piece POT dans les données clientDemandePieceProposee
                      let statutPiece = panier?.some(
                        (item: any) =>
                          item.potObj?.id === pcs.typePiecePOT[lastIndex]?.id &&
                          item.statut === 'A_PROPO'
                      )

                      const piecePOT = {
                        ...pcs?.typePiecePOT[lastIndex],
                        demandePiece: pieceRechercheSelected,
                        status: statutPiece ? 'A_PROPO' : 'PROPO',
                      }
                      setSelectedPOTAriane(piecePOT)
                      setPieceSelected(null)
                      setIsEditPiece(true)
                      setIsEditPanier(false)
                    }}
                  >
                    Visualisation du POT actuel
                  </button>
                </div>
              )}
              {/*fin de la réactivation de la pièce POT*/}

              {/* début modification de la pièce POT*/}
              {pcs?.typePiecePOT?.length > 0 && createPOT && (
                <div>
                  <button
                    className='btn btn-bg-light btn-active-color-primary btn-sm'
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Réactiver la POT'
                    data-tooltip-place='left'
                    onClick={(e) => {
                      e.stopPropagation()
                      reactivePOT(pcs)
                    }}
                  >
                    Réactiver la POT
                  </button>
                </div>
              )}
              {/*fin modification de la pièce POT*/}
              {state?.isAssign &&
                !isDemandeDemontage &&
                createPOT &&
                pcs?.statut !== 'NON_DISPONIBLE' && (
                  <div>
                    <span
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                      data-bs-toggle='modal'
                      data-bs-target='#modalPOT'
                      data-tooltip-id='tooltip'
                      data-tooltip-content='Ajouter pièce POT'
                      data-tooltip-place='left'
                      onClick={(e) => {
                        e.stopPropagation()
                        selectedPiece(pcs)
                        setPieceInstance(`${pcs?.id}_${i + 1}`)
                        setPieceSelected(pcs)
                        setSelectedPOTAriane(null)
                      }}
                    >
                      <i className='bi bi-tools fs-3'></i>
                    </span>
                  </div>
                )}

              {state?.isAssign && isCreateDemontage && pcs?.statut !== 'NON_DISPONIBLE' && (
                <div>
                  <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                    {(() => {
                      let iconColor = 'text-primary'
                      let tooltipContent = 'Demande de démontage de pièce'
                      let isDisabled = false

                      let statutCode = ''
                      if (pcs?.demandeDemontage) {
                        isDisabled = true
                        statutCode = pcs?.demandeDemontage?.statut?.code

                        if (statutCode === 'NOUVELLE') {
                          iconColor = 'text-secondary'
                          tooltipContent = 'Envoyée'
                        } else if (statutCode === 'VALIDE') {
                          iconColor = 'text-info'
                          tooltipContent = 'Validée'
                        }
                        // } else if (statutCode === 'REFUS') {
                        //   iconColor = 'text-danger'
                        //   tooltipContent = 'Refusée'
                        // }
                        else if (statutCode === 'EN COURS') {
                          iconColor = 'text-warning'
                          tooltipContent = 'En cours'
                        } else if (pcs?.demandeDemontage?.demandeTypePiece) {
                          const pieceFound = pcs.demandeDemontage.demandeTypePiece.find(
                            (item) => pcs?.typePiece?.id === item?.typePiece?.id
                          )

                          if (pieceFound) {
                            if (pieceFound.realise) {
                              iconColor = 'text-success'
                              tooltipContent = 'Démontée'
                            }
                            // else if (!pieceFound.realise && pieceFound.refus !== '') {
                            //   iconColor = 'text-danger'
                            //   tooltipContent = 'Refusée'
                            // }
                          }
                        }
                      }

                      return pcs?.demandeDemontage && statutCode !== 'REFUS' ? (
                        statutCode === 'VALIDE' || statutCode === 'DEMONTEE' ? (
                          <i
                            className={`bi bi-car-front fs-2 ${iconColor}`}
                            style={{
                              fontWeight: 'bold',
                              verticalAlign: 'middle',
                              cursor: 'pointer',
                              opacity: 1,
                            }}
                            data-tooltip-id='tooltip'
                            data-tooltip-content={tooltipContent}
                            data-tooltip-place='right'
                            data-bs-target='#modal_details_demont'
                            data-bs-toggle='modal'
                            data-bs-dismiss='modal'
                            onClick={(e) => {
                              e.stopPropagation()
                              showDetailDemontage(pcs)
                            }}
                          />
                        ) : (
                          <i
                            className={`bi bi-car-front fs-2 ${iconColor}`}
                            style={{
                              fontWeight: 'bold',
                              verticalAlign: 'middle',
                              cursor: isDisabled ? 'not-allowed' : 'pointer',
                              opacity: isDisabled ? 0.5 : 1,
                            }}
                            data-tooltip-id='tooltip'
                            data-tooltip-content={tooltipContent}
                            data-tooltip-place='right'
                          />
                        )
                      ) : (
                        <Link
                          to='/demontage/liste'
                          state={{
                            marque: pcs?.marque,
                            modele: pcs?.modele,
                            vin: haveImmat
                              ? pcs?.clientDemandeImmat?.donneesImmatriculation?.sVin
                              : null,
                            immatriculation: haveImmat
                              ? pcs?.clientDemandeImmat?.immatriculation
                              : null,
                            typePiece: pcs?.typePiece,
                            isVHT: !!pcs.clientDemandeImmat?.vehiculeHorsType,
                            demandeId: pcs?.demande?.id,
                            clientId: pcs?.demande?.client?.id,
                            typePieceHn: pcs?.typePieceHn ?? null,
                            isFromDemande: true,
                            isFromPOT: state?.isFromPOT,
                            clientDemandeImmat: pcs.clientDemandeImmat?.id,
                            pieceSelected: pcs,
                            filters: state?.filters,
                            currentState: locationState,
                            pieceInstance: `${pcs?.id}_${i + 1}`,
                          }}
                          style={{textDecoration: 'none'}}
                        >
                          <i
                            className={`bi bi-car-front fs-2 ${iconColor}`}
                            style={{
                              fontWeight: 'bold',
                              verticalAlign: 'middle',
                              cursor: 'pointer',
                              opacity: 1,
                            }}
                            data-tooltip-id='tooltip'
                            data-tooltip-content={tooltipContent}
                            data-tooltip-place='right'
                          />
                        </Link>
                      )
                    })()}
                  </span>
                </div>
              )}
              {/*<div>*/}
              {/*  <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>*/}
              {/*    <i className='bi bi-car-front'></i>*/}
              {/*  </span>*/}
              {/*</div>*/}
            </div>
          </div>
        ))
      })
    )
  }

  useEffect(function otherDataInitValueFromLocState() {
    if (state?.otherData) setOtherData(state?.otherData)
  }, [])

  const handleUpdateClientData = (tempClientId, radioValue, tempContactedBy, communicationMode) => {
    setClientId(tempClientId)
    setContactedBy(tempContactedBy)
    setLoadingCLientInfo(true)

    changeClientOnDemande(
      tempClientId,
      state?.demandeId,
      radioValue,
      tempContactedBy,
      communicationMode,
      panier.map((p) => p.idPiecePropose)
    ).then((res) => {
      if (res?.status !== 200) {
        console.error('Erreur lors de la changement de client')
      } else {
        setDemandeClient(res?.data?.demande)
        setPiecePropData(res?.data?.panier)

        const demande = res?.data?.demande
        const client = res?.data?.client

        setRetraitDepot(demande?.retraitDepot)

        // Mise à jour du panier avec le taux de remise du nouveau client
        const finalPanier = panier?.map((piece) => {
          const responsePanier = res?.data?.panier
          const pieceResponsePanier = responsePanier?.find(
            (panier) => panier?.id === piece?.idPiecePropose
          )

          // TVA POT toujours 20%
          const isProfessionnel = piece?.isTypePiecePOT
            ? 20
            : client && client?.professionnel === false
            ? 10
            : 20
          const fraisDePort = demande?.retraitDepot
            ? 0
            : Number(pieceResponsePanier?.prixTransport) ?? 0
          const fraisDePortInitial = Number(pieceResponsePanier?.prixTransport) ?? 0

          const taux = Number(pieceResponsePanier?.tauxRemise ?? 0)
          const tauxTva = Number(piece?.tauxTva ?? 0)
          const prix = Number(piece?.prix ?? 0)

          const prixReferentielTtc = Number(prix * (1 + tauxTva / 100)) ?? 0
          const prixReferentielHtInitial =
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ?? 0
          const prixReferentielHt = Number(pieceResponsePanier?.prixReferentiel) ?? 0

          const prixVenteProposeeHt =
            Number(prixReferentielHt - prixReferentielHt * (taux / 100)) ?? 0
          const prixVenteProposeeTtc =
            Number(prixVenteProposeeHt * (1 + isProfessionnel / 100)) ?? 0
          const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

          return {
            ...piece,
            tauxRemise: Number(taux?.toFixed(1)),
            montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
            prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
            prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
            prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
            prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
            prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
            fraisDePort: Number(fraisDePort?.toFixed(2)),
            fraisDePortInitial: Number(fraisDePortInitial?.toFixed(2)),
          }
        })
        setPanier(finalPanier)

        if (finalPanier && initialPieces.length === 0) {
          const copieInitiale = finalPanier
            .filter((p) => p.statut === 'PROPO')
            .map((p) => {
              return {
                id: p.id,
                tauxRemise: Number(p?.tauxRemise ?? 0),
                montantRemise: Number(p?.montantRemise ?? 0),
                fraisDePort: Number(p.fraisDePort ?? 0),
                fraisDePortInitial: Number(p.fraisDePort ?? 0),
                prixReferentielHt: Number(p?.prixReferentielHt ?? 0),
                prixReferentielTtc: Number(p?.prixReferentielTtc ?? 0),
                prixVenteProposeeHt: Number(p?.prixVenteProposeeHt ?? 0),
                prixVenteProposeeTtc: Number(p?.prixVenteProposeeTtc ?? 0),
              }
            })
          setInitialPieces(copieInitiale)
        }

        // Récupération des données clients après le changement
        getClient(tempClientId).then((resClient) => {
          if (resClient?.status === 200 && resClient?.data?.id) {
            const updatedData = {...resClient.data}
            updatedData.idPays = updatedData.pays?.id
            clientDataRef.current = updatedData
            setData(updatedData)

            // Stockage du nouveau Client Id et des données en cas de rechargement de la page
            navigate(location.pathname, {
              state: {
                ...state,
                clientId: tempClientId,
                dataClientInfos: updatedData,
                demandeClient: res?.data?.demande,
              },
              replace: true,
            })

            // Récup. des données suppl.
            getClientOtherData(tempClientId, state?.demandeId).then((clientRequest) => {
              if (clientRequest?.status === 200) {
                const updatedOtherData = Object.assign({...updatedData}, clientRequest?.data)
                setOtherData({...updatedOtherData})
              }
            })

            getAdresseFacturationData(tempClientId).then((adresseRequest) => {
              if (adresseRequest?.status === 200) {
                setAdresseFacturation(adresseRequest?.data)
              }
            })

            if (updatedData.typeClient === 'PROSPECT') {
              setIsProspect(true)
            }
            setLoadingCLientInfo(false)
          } else {
            navigate('/vente/clients/liste')
          }
        })
      }
    })

    getAllClientAdresses(tempClientId)
  }

  // Setter la valeur de duplicate en false
  const toggleDuplicate = () => {
    setIsDuplicate(false)
  }

  // Récupération des adresses clients pour les affichers dans le composant AdresseClient
  const getAllClientAdresses = (clientId) => {
    setLoadingAdresse(true)
    getClientAdresses(clientId).then((res) => {
      if (res.status === 200) {
        setLoadingAdresse(false)
        setClientAdresses(res.data)
      }
    })
  }

  useEffect(() => {
    renderTypePiece()
  }, [panier])

  const getAdresseRetraitDepot = async (source: string) => {
    setLoadingDepot(true)

    if (abortController.current) {
      abortController.current.abort()
    }
    const controller = new AbortController()
    abortController.current = controller

    try {
      const res = await getAdresseDepotBySourceDemande(source, controller.signal)
      if (res.data) setAdresseDepots(res.data)
    } catch (e) {
      if (axios.isAxiosError(e) && e.code === 'ERR_CANCELED') {
        return
      }
      console.error(e)
    } finally {
      if (abortController.current === controller) {
        setLoadingDepot(false)
      }
    }
  }

  return (
    <>
      <div className='d-flex align-items-center justify-content-between mb-3'>
        <Link
          to={`/demandes/${clientId}/traitement/${state?.selectedPiecesFromVehicle[0]?.demande?.id}`}
          state={{
            filters: state?.filters,
            clientId: clientId,
            retraitDepot: retraitDepot,
            commentaireInterne: commentaireInterne,
            idFormattedArr: state?.statePagination?.idFormattedArr,
            pagination: state?.statePagination?.pagination,
            loadedFromPage: state?.statePagination?.loadedFromPage,
            loadedToPage: state?.statePagination?.loadedToPage,
            activeFilters: state?.statePagination?.activeFilters,
          }}
          className='btn btn-light'
          title='Retour'
        >
          <i className='ki-duotone ki-arrow-left fs-3'>
            <span className='path1'></span>
            <span className='path2'></span>
          </i>
          Retour
        </Link>
        <DemandeAssignation
          data={state?.demandeClient}
          setDemandeClient={setDemandeClient}
          demandeClient={state?.demandeClient}
          setIsAssign={setIsAssign}
        />
      </div>
      <div className={'card my-3'}>
        {loadingCLientInfo ? (
          <LoadingData />
        ) : (
          <>
            <div className='d-flex flex-row justify-content-between card'>
              <ClientInfos
                clientData={clientDataRef.current}
                demandeId={state?.demandeId}
                otherData={otherData}
                loadingCLientInfo={loadingCLientInfo}
                isProspect={isProspect}
                clientAdresses={clientAdresses}
                contactedBy={null}
                clientDemandeStatus={state?.clientDemandeStatus}
                setClientAdresseEdit={setClientAdresseEdit}
                refetchClientData={refetchClientData}
                setRefetchClientData={setRefetchClientData}
              />
              <HeaderDemandeTraitement
                demandeId={state?.demandeId}
                data={demandeClient}
                setIsAssign={null}
                redirectToClientDemande={state?.redirectToClientDemande}
                onEdit={false}
                autoAssign={null}
                setDemandeClient={null}
                demandeClient={demandeClient}
                canCreate={shouldDisplayFonctionnalite(currentUser, 'AJOUTER DEMANDE')}
              />
            </div>
            {/*Affichage "Plus d'informations"*/}
            <ClientMoreInfos
              otherData={otherData}
              demandeId={state?.demandeId}
              demandeClient={state?.demandeClient}
              clientData={clientDataRef.current}
              isConfirmEdit={isConfirmEdit}
              contentCommunication={contentCommunication}
              contactedByBloc={contactedByBloc}
              setContactedByBloc={setContactedByBloc}
              radioValue={radioValue}
              contactedBy={contactedBy}
              showMoreClientInfo={showMoreClientInfo}
              setShowMoreClientInfo={setShowMoreClientInfo}
            />
            {/*Affichage "Adresse Facturation/Livraison"*/}
            <AdresseClient
              clientData={clientDataRef.current}
              clientAdresses={clientAdresses}
              updatedAdresseLivInfo={updatedAdresseLivInfo}
              setUpdatedAdresseLivInfo={setUpdatedAdresseLivInfo}
              updatedAdresseFactInfo={updatedAdresseFactInfo}
              setUpdatedAdresseFactInfo={setUpdatedAdresseFactInfo}
              isAdresseUpdated={isAdresseUpdated}
              setIsAdresseUpdated={setIsAdresseUpdated}
              errorsFac={errorsFac}
              errorsLiv={errorsLiv}
              fromDemandeForm={false}
              loadingAdresse={loadingAdresse}
              retraitDepot={retraitDepot}
              setRetraitDepot={setRetraitDepot}
              setPanier={setPanier}
              setInitialPieces={setInitialPieces}
              loadingDepot={loadingDepot}
              setClientAdresseEdit={setClientAdresseEdit}
              livraisonSelectedValue={livraisonSelectedValue}
              setLivraisonSelectedValue={setLivraisonSelectedValue}
              facturationSelectedValue={facturationSelectedValue}
              setFacturationSelectedValue={setFacturationSelectedValue}
              clientAdresseData={clientAdresseData}
            />
          </>
        )}
      </div>

      {images?.length > 0 && (
        <div className='card p-5 rounded-1 mb-xl-10'>
          <DemandePj images={images} setImages={setImages} isTraitementDemande={true} />
        </div>
      )}

      <div className='card border p-5 mb-3'>
        <h3 className='mb-3'>Informations véhicule</h3>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-150px'>Marque</th>
                <th className='min-w-150px'>Modèle</th>
                <th className='min-w-150px'>Immatriculation</th>
                <th className='min-w-150px'>VIN</th>
              </tr>
            </thead>
            <tbody>{renderFormRowImmat()}</tbody>
          </table>
        </div>
      </div>
      <div className='card border p-5 mb-3'>
        <h3 className='mb-3'>Pièces à rechercher</h3>
        <div className='d-flex flex-column gap-3 overflow-y-auto' style={{maxHeight: '600px'}}>
          {renderTypePiece()}
        </div>
      </div>
      {/* debut champs recherche */}
      <VehicleSearchFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        formik={formik}
        customStyles={customStyles}
        marqueVehicule={marqueVehicule}
        valueMarque={valueMarque}
        setValueMarque={setValueMarque}
        modeleVehicule={modeleVehicule}
        valueModele={valueModele}
        setValueModele={setValueModele}
        pieceTypePiece={pieceTypePiece}
        selectedSearchValue={selectedSearchValue}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        pieceSpinner={pieceSpinner}
        resultShowPiece={resultShowPiece}
        clearInput={clearInput}
        setIsSearch={setIsSearch}
        setClearInput={setClearInput}
        setFormattedCodePiece={setFormattedCodePiece}
        setSearchPage={setSearchPage}
        setSelectedSearchValue={setSelectedSearchValue}
        setResultShowPiece={setResultShowPiece}
        allModeleVehicule={allModeleVehicule}
        setModeleVehicule={setModeleVehicule}
        setPieceTypePiece={setPieceTypePiece}
        setPieceSpinner={setPieceSpinner}
        timeoutRef={timeoutRef}
        referenceConstValue={referenceConstValue}
        setReferenceConstValue={setReferenceConstValue}
        setSortField={setSortField}
        setSortOrder={setSortOrder}
        piecePubliable={piecePubliable}
        setPiecePubliable={setPiecePubliable}
        rechercheSite={state?.selectedSite ?? null}
      />
      {/* fin champs recherche */}
      <div className='card border'>
        <div className='card-header d-flex justify-content-between align-items-center border-bottom-0'>
          <div className='d-flex gap-5 justify-content-between pt-9' style={{flex: 1}}>
            <p className='fw-bold'>Nombre de pièces trouvées : {loading ? '' : totalPages}</p>
            <div className='d-flex gap-5'>
              {listPiecesArr.length === 0 && isNotAvailable && (
                <span
                  className='cursor-pointer d-flex gap-4 align-items-center btn btn-light-success py-0 border border-success'
                  data-tooltip-id='tooltip'
                  data-tooltip-content='Assistance AI'
                  data-tooltip-place='right'
                  data-bs-target='#modalAI'
                  data-bs-toggle='modal'
                  data-bs-dismiss='modal'
                  onClick={() => getResultShowPiece('')}
                >
                  <i>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='32'
                      height='32'
                      viewBox='0 0 24 24'
                    >
                      <path
                        fill='#2c91a3'
                        fill-rule='evenodd'
                        d='M8.75 4a.75.75 0 0 0-1.5 0v1.25H7A1.75 1.75 0 0 0 5.25 7v.25H4a.75.75 0 0 0 0 1.5h1.25v2.5H4a.75.75 0 0 0 0 1.5h1.25v2.5H4a.75.75 0 0 0 0 1.5h1.25V17c0 .966.784 1.75 1.75 1.75h.25V20a.75.75 0 0 0 1.5 0v-1.25h2.5V20a.75.75 0 0 0 1.5 0v-1.25h2.5V20a.75.75 0 0 0 1.5 0v-1.25H17A1.75 1.75 0 0 0 18.75 17v-.25H20a.75.75 0 0 0 0-1.5h-1.25v-2.5H20a.75.75 0 0 0 0-1.5h-1.25v-2.5H20a.75.75 0 0 0 0-1.5h-1.25V7A1.75 1.75 0 0 0 17 5.25h-.25V4a.75.75 0 0 0-1.5 0v1.25h-2.5V4a.75.75 0 0 0-1.5 0v1.25h-2.5zm-2 3A.25.25 0 0 1 7 6.75h10a.25.25 0 0 1 .25.25v10a.25.25 0 0 1-.25.25H7a.25.25 0 0 1-.25-.25zm5.049 7.753l-.275-.772H9.497l-.275.772a.75.75 0 0 1-1.413-.504l1.7-4.77l.003-.009l.004-.01c.152-.392.516-.711.994-.711c.479 0 .842.319.995.712l.003.009l.004.01l1.7 4.77a.75.75 0 0 1-1.413.503m-1.289-3.615l.479 1.343h-.958zm3.74-1.64a.75.75 0 0 1 1.5 0v5.003a.75.75 0 1 1-1.5 0z'
                        clip-rule='evenodd'
                      />
                    </svg>
                  </i>
                  Assistance IA
                </span>
              )}

              <PieceNotAvailable
                clientId={state?.selectedPiecesFromVehicle[0]?.demande?.client?.id}
                idTypePiece={idTypePiece}
                redirectToClientDemande={state?.redirectToClientDemande}
                demandeId={state?.selectedPiecesFromVehicle[0]?.demande?.id}
                idDemandePiece={idClientDemandePiece}
                filters={locationState?.filters}
                otherData={otherData}
                dataClientInfos={clientDataRef.current}
                isAvailable={isAvailable}
                onPieceChange={handleStatusPieces}
                setDemandeClient={setDemandeClient}
                // haveMultiplePiece={pieces?.length > 1}
                haveMultiplePiece={clientDemandepieces?.length > 1}
                pieces={clientDemandepieces}
                setPieces={setPieces}
                setClientDemandePieces={setClientDemandePieces}
              />

              <ShopModal
                clientId={clientId}
                demandeId={state?.selectedPiecesFromVehicle[0]?.demande?.id}
                panier={panier}
                setPanier={setPanier}
                isProspect={state?.isProspect}
                idPiecePropose={idClientDemandePiece}
                pieces={clientDemandepieces}
                setPieces={setClientDemandePieces}
                dataClientInfos={clientDataRef.current}
                otherData={otherData}
                loadingCLientInfo={loadingCLientInfo}
                totalPanier={panier.length}
                setPiecesProps={setPieces}
                filters={locationState?.filters}
                demandeClient={demandeClient}
                setDemandeClient={setDemandeClient}
                fromListePieceStock={state?.fromListePieceStock}
                provenances={provenances}
                isAdresseUpdated={isAdresseUpdated}
                updatedAdresseLivInfo={updatedAdresseLivInfo}
                updatedAdresseFactInfo={updatedAdresseFactInfo}
                // handleDismiss={state?.handleDismiss}
                adresseFacturation={locationState?.adresseFacturation}
                errorsFac={errorsFac}
                setErrorsFac={setErrorsFac}
                errorsLiv={errorsLiv}
                setErrorsLIv={setErrorsLIv}
                requierdFieldFac={state?.requierdFieldFac}
                requierdFieldLiv={state?.requierdFieldLiv}
                updatedFinalAdresseLivInfo={updatedFinalAdresseLivInfo}
                setUpdatedFinalAdresseLivInfo={setUpdatedFinalAdresseLivInfo}
                updatedFinalAdresseFactInfo={updatedFinalAdresseFactInfo}
                setUpdatedFinalAdresseFactInfo={setUpdatedFinalAdresseFactInfo}
                clientAdressesFacLiv={clientAdresses}
                isConfirmEdit={isConfirmEdit}
                setIsEdit={setIsEdit}
                contactedByBloc={contactedByBloc}
                setContactedByBloc={setContactedByBloc}
                contactedBy={contactedBy}
                setContactedBy={setContactedBy}
                contentCommunication={contentCommunication}
                radioValue={radioValue}
                piecePropData={piecePropData}
                isLoadingProvenance={isLoadingProvenance}
                loading={loadingPanier}
                clientDemandeStatus={state?.clientDemandeStatus}
                refetchClientAdresses={getAllClientAdresses}
                retraitDepot={retraitDepot}
                setRetraitDepot={setRetraitDepot}
                initialPieces={initialPieces}
                setInitialPieces={setInitialPieces}
                checkedPieces={checkedPieces}
                setCheckedPieces={setCheckedPieces}
                totalLibelle={totalLibelle}
                setTotalLibelle={setTotalLibelle}
                adresseDepots={adresseDepots}
                loadingDepot={loadingDepot}
                getAdresseRetraitDepot={getAdresseRetraitDepot}
                commentaireInterne={commentaireInterne}
                setCommentaireInterne={setCommentaireInterne}
                setIsEditPanier={setIsEditPanier}
                livraisonSelectedValue={livraisonSelectedValue}
                setLivraisonSelectedValue={setLivraisonSelectedValue}
                facturationSelectedValue={facturationSelectedValue}
                setFacturationSelectedValue={setFacturationSelectedValue}
                clientAdresseData={clientAdresseData}
                setReloadLibelle={setReloadLibelle}
                reloadLibelle={reloadLibelle}
                clientContacts={clientContacts}
                getDemandeProp={getDemandeProp}
              />
            </div>
          </div>
        </div>
        <div className='card-body'>
          {loading ? (
            <LoadingData />
          ) : (
            <>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 gy-7'>
                  <thead>
                    <tr className='fw-bolder fs-6 text-gray-800'>
                      {showTable ? (
                        <>
                          {/*<th>Code pièce</th>*/}
                          <th className='min-w-140px'>
                            <SortableHeader title='Type pièce' label='typePiece' />
                          </th>
                          <th className='min-w-140px' style={{minWidth: '120px'}}>
                            <SortableHeader title='Marque' label='marque' />
                            <SortableHeader title='Modèle' label='modele' />
                          </th>
                          <th className='min-w-140px' style={{minWidth: '120px'}}>
                            <SortableHeader title='NE' label='NE' />
                          </th>
                          <th className='min-w-140px'>
                            <SortableHeader title='Ref. constr.' label='refConst' textHover='Ref. Constructeur'/>
                          </th>
                          <th className='min-w-150px'>
                            <SortableHeader title='Prix constr..' label='prixConst' textHover='Prix contructeur (HT)'/>
                          </th>
                          <th className='min-w-150px'>
                            <SortableHeader title='Prix TTC' label='prixVente' textHover='Prix vente (TTC)'/>
                          </th>
                          <th className='min-w-140px'>
                            <SortableHeader title='Etat' label='etat' />
                          </th>
                          <th className='min-w-150px'>
                            <SortableHeader
                              title='Date MEC'
                              label='dateCirculation'textHover='Date mise en circulation'
                            />
                          </th>
                          <th className='min-w-140px'>
                            <SortableHeader title='Réf.stock' label='refStockage' textHover='Référence stockage' />
                          </th>
                          <th className='min-w-130px'>
                            <SortableHeader title='Jour sto..' label='dateStockage' textHover='Jour de stockage' />
                          </th>
                          <th className='min-w-140px'>
                            <SortableHeader title='Comment.' label='commentaire' textHover='commentaire'/>
                          </th>
                          {showDestination &&
                            <th className='min-w-100px'>
                              <SortableHeader title='Destination' label='destination' />
                            </th>
                          }
                          <th className='min-w-140px text-end'>Action</th>
                        </>
                      ) : (
                        <>
                          {/*<th>Code pièce</th>*/}
                          <th>Type pièce</th><th>
                            <div>Marque</div>
                            <div>Modèle</div>
                          </th>
                          <th>NE</th>
                          <th>Ref. Constructeur</th>
                          <th>Prix contructeur (HT)</th>
                          <th>Prix vente min (HT)</th>
                          <th>Prix vente max (HT)</th>
                          <th>En stock</th>
                          <th>Sur le marché</th>
                          <th>Action</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {listPiecesArr.length > 0 ? (
                      renderFormRowPieces(showTable)
                    ) : (
                      <tr>
                        <td colSpan={12} className='text-center'>
                          {showTable ? 'Pas de détail disponible' : 'Pas de pièce en stock'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <Pagination
                totalPages={totalPages}
                nombreDePages={nombreDePages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                locationState={locationState}
              />

              {/* Notifications + Tooltip */}
              <Tooltip id='tooltip' />
            </>
          )}
        </div>
      </div>
      <CommentaireClientDemande
        idClientDemande={locationState?.selectedPiecesFromVehicle[0]?.demande?.id}
        clientId={state?.selectedPiecesFromVehicle[0]?.demande?.client?.id}
      />
      <DetailsModal
        data={dataToDisplayVoirToutes}
        pieces={listPiecesArr}
        idClientDemandePiece={idClientDemandePiece}
        pieceToValidate={pieceToValidate}
        setPieceToValidate={setPieceToValidate}
      />
      <DemontageModal
        objectSearch={objectSearch}
        panier={panier}
        setPanier={setPanier}
        retraitDepot={retraitDepot}
        dataClientInfos={clientDataRef.current}
        setDemandeClient={setDemandeClient}
        idClientDmdPieceDemonter={idClientDmdPieceDemonter}
        setPiecesProps={setPieces}
        piecesProps={pieces}
      />
      <ModalPOT
        piece={pieceSelected ?? selectedPOTAriane}
        showToastPOT={showToastPOT}
        setPiecesProps={setPieces}
        setPieceSelected={setPieceSelected}
        // panier={panier}
        setPanier={setPanier}
        // allPieces={locationState?.pieces}
        setAllPieces={setPieces}
        piecesProps={pieces}
        state={state}
        dataClientInfos={clientDataRef.current}
        provenances={provenances}
        isEdit={pieceSelected ? false : !!selectedPOTAriane}
        setDemandeClient={setDemandeClient}
        isEditPanier={isEditPanier}
        isEditPiece={isEditPiece}
        setIsEditPanier={setIsEditPanier}
        setIsEditPiece={setIsEditPiece}
        pieceInstance={pieceInstance}
      />

      {/*Modal Sélection choix de provenance pour la pièce*/}
      <ProvenanceModal
        selectedProvenance={selectedProvenance}
        setSelectedProvenance={setSelectedProvenance}
        pieceToValidate={pieceToValidate}
        provenances={provenances}
        validateAddPanier={validateAddToPanier}
        isLoadingProvenance={isLoadingProvenance}
      />

      {/*Début modal IA*/}
      <ModalAI
        modalRef={modalRef}
        loadingModalContent={loadingModalContent}
        modalContent={modalContent}
      />
      {/*FIn modal IA*/}

      {/*Modal affichage changement de client*/}
      <ResearchClientModal
        setClientId={setClientId}
        clientId={clientId}
        setTempClientId={setTempClientId}
        setIsClientSociety={setIsClientSociety}
        setIsCreateViaModal={setIsCreateViaModal}
        defaultValueContact={null}
        demandeSources={null}
        sourceLoader={null}
        choicedDemandeSource={demandeSourceValue}
        setChoicedDemandeSource={null}
        transformedSource={null}
        isEdit={true}
        handleUpdateClientData={handleUpdateClientData}
        setTempClient={setTempClient}
        isPrevious={isPrevious}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />

      {/*Modal choix de contact client*/}
      <ChoixContactModal
        clientId={clientId}
        setDefaultValueContact={setDefaultValueContact}
        defaultValueContact={defaultValueContact}
        isFromAddClientContact={null}
        setIsFromAddClientContact={null}
        setRadioValue={setRadioValue}
        isClientSociety={isClientSociety}
        isFromClientList={false}
        setContactedBy={setContactedByDm}
        radioValue={radioValue}
        setContentCommunication={setContentCommunication}
        contentCommunication={contentCommunication}
        isDuplicate={isDuplicate}
        setIsDuplicate={setIsDuplicate}
        toggleDuplicate={toggleDuplicate}
        isEdit={true}
        handleUpdateClientData={handleUpdateClientData}
        tempClientId={tempClientId}
        demandeId={state?.demandeId}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      {/*Modal création de client*/}
      <AddClientModal
        setClientId={setClientId}
        setOpenModalResVeh={setOpenModalResVeh}
        isCreateViaModal={isCreateViaModal}
        openModalResVeh={openModalResVeh}
        fromChangeClient={true}
        setTempClientId={setTempClientId}
      />
      <ConfirmVBModal
        demande={demandeClient}
        handleList={updDemande}
        setDemandeClient={setDemandeClient}
        setPanier={setPanier}
      />

      {/*modal ajout d'adresse pour le client selectionné*/}
      <ClientAdresseFormModal
        clientId={state?.dataClientInfos?.id}
        clientAdresses={clientAdresses}
        setClientAdresses={setClientAdresses}
        clientAdresseEdit={clientAdresseEdit}
        setRefetchClientData={setRefetchClientData}
        setClientAdresseData={setClientAdresseData}
        isFromFicheClient={true}
      />
    </>
  )
}
export {ListePieceStock}
